<template>
  <DeleteModal ref="deltModal" />
  <ExplainModal ref="explainPra" :viewName="loadedView"></ExplainModal>
  <KeyDeep ref="keyDeepModal" :getKeyInfoC="send_ins" :getPins="passpinInfo" :getpass="getWc" v-if="isKeyDeep"
    @closeKDeep="closeKDeep" :getcolumnpriorToChild="getcolumnpriorToChild" />
  <renameviewMod ref="renameViewMd" :isExist="isExist" @renamedView="viewsetting" />
  <div class="modal fade" id="fliterPopup" tabindex="-1" aria-labelledby="fliterPopup" data-bs-backdrop="static"
    aria-hidden="true">
    <div class="modal-dialog modal-xl large-modal modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select Filter Levels</h5>
          <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close" @click="fliterPopup.hide()">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center mt-4" style="z-index:2">
            <div class="col-4 text-end">
              <div class="d-flex align-items-center">
                <button @click="resetMinMax(0, slider.resetMin)" :title="'Reset - ' + slider.resetMin"
                  class="reset-btn mx-1">
                  <i class="fas fa-undo themeclr2 "></i>
                </button>
                <label for="maxValue " class="me-2">Min:</label>
                <input type="number" class="form-control" id="maxValue" v-model="slider.minValue" />
              </div>
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center">
                <button @click="resetMinMax(1, slider.resetMax)" :title="'Reset - ' + slider.resetMax"
                  class="reset-btn mx-1">
                  <i class="fas fa-undo themeclr2 "></i>
                </button>
                <label for="maxValue" class="me-2">Max:</label>
                <input type="number" class="form-control" id="maxValue" v-model="slider.maxValue" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="effect btn-filter eff-md" v-on:click="getwidgetrange();">
            Filter
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="wrapper container-fluid">
    <div class="myLoadBack 2" v-show="clickInsightLoad">
      <div class="d-flex align-items-center justify-content-center h-100">
        <pageLoaderComp></pageLoaderComp>
      </div>
    </div>
    <div class="myLoadBack 1" v-show="!isAnalysisloaded">
      <analzerLoaderComp></analzerLoaderComp>
    </div>
    <div class="myLoadBack 2" v-show="!isInsightloaded">
      <div class="d-flex align-items-center justify-content-center h-100">
        <pageLoaderComp></pageLoaderComp>
      </div>
    </div>
    <div class="backgroundGrey" v-show="showAsmtSettingsIn || showViewList"></div>
    <div class="deletePopUp" v-if="showDeleteModal">
      <div class="modal-content deleteModal pindelpdd">
        <div class="modal-header delpinht">
          <h5 class="modal-title">Delete View</h5>
          <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
            v-on:click="showDeleteModal = false" style="position: relative;float: right;margin: inherit;">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <label class="col-sm-12 nopadding">
              Are you sure that you want to delete "{{ selectedDelName }}"?
              <br>
              <small class="text-danger">This action cannot be reversed.</small>
            </label>
          </div>
        </div>
        <div class="modal-footer delpinfoot">
          <a class="effect btn-delete eff-md delpinbtnbg" v-on:click="okDeleteView()"
            style="margin-right: 5px; color: #dc3545 !important;">
            Delete</a>
          <div class="btn stdBtn btn-bordered" v-on:click="showDeleteModal = false">
            <b>Cancel</b>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-content showAsmtSettings mdl" v-show="showAsmtSettingsIn"
      style="height: 85vh; overflow: auto; left:40px;">
      <div class="myLoadBack 2" v-show="settingLoader">
        <div class="d-flex align-items-center justify-content-center h-100">
          <pageLoaderComp></pageLoaderComp>
        </div>
      </div>
      <div class="modal-header">
        <h4 class="modal-title">Assessment Level Insight Settings <small class="text-muted" v-if="!isOwner">(Read-only
            view)</small></h4>
        <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
          v-on:click="showAsmtSettingsIn = !showAsmtSettingsIn;">
          <div class="leftright"></div>
          <div class="rightleft"></div>
        </div>
      </div>
      <div class="contbg row" style="padding: 20px;z-index: 2;">
        <div class="col-12">
          <fieldset class="row">
            <legend class="themeclr2 theme-text text-bold">Weekend Configuration:</legend>
            <div class="row" style="padding:15px 10px">
              <div class="col-12">
                <div class="form-check inline-block me-4">
                  <input class="form-check-input radio" type="radio" value="wess" v-model="we_mode" name="weekend"
                    id="wess">
                  <label class="form-check-label" for="wess">
                    Sat/Sun
                  </label>
                </div>
                <div class="form-check inline-block">
                  <input class="form-check-input radio" type="radio" value="wefs" v-model="we_mode" name="weekend"
                    id="wefs">
                  <label class="form-check-label" for="wefs">
                    Fri/Sat
                  </label>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset class="row" style="margin-top: 20px;">
            <legend class="themeclr2 theme-text text-bold">KPI Configuration:</legend>
            <label class="container" v-show="isDataPattern == 'homoData'">
              <input type="checkbox" checked="checked" v-model="isImport">
              Use Default Settings
              <span class="checkmark"></span>
            </label>
            <div class="col-lg-6 col-sm-12 mr10top" v-for="(scrlabels, index) in getscorelbls" :key="index + 'kpiconfig'">
              <label class="text-bold"> {{ scrlabels.label }} </label>
              <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" :id="'vueMulti' + index"
                v-model="scrlabels.value" :options="scrlabels.opt" :multiple="true" :close-on-select="false"
                placeholder="Pick" label="valname" track-by="valname" :disabled="isDataPattern == 'homoData'"
                selectLabel="" />
            </div>
          </fieldset>
          <fieldset class="row" sv-root="critId" style="margin-top: 20px;padding: 10px 15px;">
            <legend class="themeclr2 theme-text text-bold">Priority's Criticality Configuration:</legend>
            <div class="col-12 col-md-4">
              <div class="panel panel-default h-100">
                <div class="panel-heading">
                  <h5 class="panel-title addOpacity text-center">
                    Business Impacting
                  </h5>
                </div>
                <div class="panel-body nopadding">
                  <draggable class="list-group drag-list" :list="criticalVal" group="bussimpact" itemKey="name">
                    <template #item="{ element }">
                      <div class="list-group-item app"><i class="fa fa-arrows-alt" aria-hidden="true"></i> {{ element }}
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <h3 class="text-center"><i class="fas fa-arrows-alt-h"></i></h3>
            </div>
            <div class="col-12 col-md-4">
              <div class="panel panel-default h-100">
                <div class="panel-heading">
                  <h5 class="panel-title addOpacity text-center">
                    Non Business Impacting
                  </h5>
                </div>
                <div class="panel-body nopadding">
                  <draggable class="list-group drag-list" :list="noncriticalVal" group="bussimpact" itemKey="name">
                    <template #item="{ element }">
                      <div class="list-group-item app"><i class="fa fa-arrows-alt" aria-hidden="true"></i> {{ element }}
                      </div>
                    </template>
                  </draggable>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset class="row" style="margin-top: 20px;">
            <legend class="themeclr2 theme-text text-bold">Set Priority Order:</legend>
            <label class="container" v-show="isDataPattern == 'homoData'">
              <input type="checkbox" checked="checked" v-model="isImport">
              Use Default Settings
              <span class="checkmark"></span>
            </label>
            <div class="panel-body nopadding col-sm-12 col-lg-6 ">
              <draggable :list="priorityOrder" :disabled="!enabled" class="list-group drag-list" ghost-class="bussimpact"
                itemKey="name">
                <template #item="{ element }">
                  <div class="list-group-item app"><i class="fa fa-arrows-alt" aria-hidden="true"></i> {{ element }}
                  </div>
                </template>
              </draggable>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row text-end p-2 pe-5 justify-content-end position-sticky sticky-bottom myAnalyzeBtnShow bottom-0" style="padding: 20px;z-index: 2;">
        <a class="effect btn-save eff-md" v-on:click="saveInsSetts()" v-if="isOwner || isWrShare == 'Y'">
          Save
        </a>
      </div>
    </div>
    <div class="modal-content showAsmtSettings mdl" v-show="showViewList">
      <div class="modal-header">
        <h4 class="modal-title">List of Saved Views</h4>
        <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
          v-on:click="showViewList = !showViewList;">
          <div class="leftright"></div>
          <div class="rightleft"></div>
        </div>
      </div>
      <div class="contbg row">
        <div class="col-12" style="padding:15px 0">
          <ag-grid-vue style="width: 96%;height:470px;"
            class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
            :modules="modules" @cell-clicked="onCellClicked" @grid-ready="onPriorAsg">
          </ag-grid-vue>
        </div>
      </div>
    </div>
    <div class="modal-content mdl colQico mdl myRename" v-show="savePopShow">
      <div class="modal-header">
        <h4 class="modal-title">DASHBOARD VIEW</h4>
        <div class="close-container myfaBtn" data-dismiss="modal" aria-label="Close"
          v-on:click="savePopShow = !savePopShow">
          <div class="leftright"></div>
          <div class="rightleft"></div>
        </div>
      </div>
      <div class="modal-body modalChart modal-bodyHt">
        <div class="row">
          <div class="col-sm-12">
            <div style="padding-right: 10px;" class="form-group">
              <label style="padding-left:0px;" class="col-sm-6">Enter Name</label>
              <input class="form-control col-sm-12" type="text" v-model="ViewName" maxlength="50" autofocus
                @input="changeViewName()">
              <label class="text-danger" v-show="isExist">View already exists, do you want to override it?</label>
              <label class="text-danger" v-show="isClone">Readonly View (owned by {{ uname }}), do you want to clone
                it?</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="effect btn-save eff-md" v-on:click="saveViewFn(0)" style="margin-right: 10px;"
          v-show="!isClone && !isExist">
          Save</div>
        <div class="effect btn-save eff-xl" v-on:click="saveViewFn(1)" style="margin-right: 10px;" v-show="isExist">
          Override & Save</div>
        <div class="effect btn-save eff-xl" v-on:click="saveViewFn(2)" style="margin-right: 10px;" v-show="isClone">
          Clone & Save</div>
        <div class="btn stdBtn btn-bordered" v-on:click="savePopShow = !savePopShow"><strong>Cancel</strong></div>
      </div>
    </div>
    <div class="row g-0">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="col-xl-6 mb-2 breadcrumbs tabMod-pane"
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          <span class="myfaBtn secondaryTxt" v-on:click="delAssessment()" ref="" v-if="isOwner">
            <font-awesome-icon :icon="['fas', 'fa-trash-alt']" />
          </span>
          <span class="myfaBtn secondaryTxt" v-on:click="bookMarkClick(AsgName)"
            :class="{ isActive: Is_bookmark == 'Yes' }">
            <font-awesome-icon v-if="(Is_bookmark == 'No')" :icon="loadicoI" />
            <font-awesome-icon v-if="(Is_bookmark == 'Yes')" :icon="loadico" />
          </span>
          {{ AsgName }}
          <i class="fa fa-angle-right"></i>
          Insight
          <i class="fa fa-angle-right"></i>
          <small style="margin-left:10px;">
            <i class="far fa-gem"></i>
          </small>
          &nbsp;<span v-on:click="showHidePanel()" class="uSpl">
            <span>{{ loadedView }}</span>
            <span v-show="loadedView == ''">Untitled</span>
            <span v-show="showEdited" class="showEdited">*</span>
            <small v-if="isReadOnlyView" class="text-muted">(Read Only View)</small>
            &nbsp;
            <font-awesome-icon icon="fa-solid fa-caret-down" class="primaryTxt cursor-pointer"
              v-on:click="showHidePanel()" />
          </span>
        </h6>
        <div class="d-flex align-items-center d-flex align-items-center col-6 justify-content-end ">
          <small class="gray-font me-3" v-if="isLive">Last modified {{$store.state.isLiveDate}}</small>
          <div class="me-2" style="padding-top:5px;">
            <a class="effect btn-setting eff-md me-2" role="button" v-on:click="showSettings()">
              <span>Settings</span>
            </a>
            <a class="effect btn-view eff-md" v-on:click="saveSetting(0)" v-show="!showWrapper" :class="showEdited ? 'blink' : ''">
              <span v-show="showEdited">Save View</span>
              <span v-show="!showEdited">Pin View</span>
            </a>
          </div>
        </div>
      </div>
      <div class="content-panel mr20top col-12" v-show="isShowSaved" style="margin: 10px;">
        <div class="container-fluid">
          <div v-show="savedSettings.length > 0">
            <div class="row">
              <div class="col-12 ">
                <h5 class="secondaryTxt"><u><i class="far fa-gem"></i>Pinned Views</u></h5>
                <a class="effect btn-list thin eff-lg" v-on:click="getViewList(true)"
                  style="float: right;margin-top: -35px;">
                  All Views List
                </a>
              </div>
            </div>
            <div class="row row-cols-auto">
              <div class="col-2" v-for="(saved, index) in savedSettings" :key="saved.id" v-show="saved.id > 0">
                <div class="viewIconSuper" v-show="saved.name != 'Overall'">
                  <div v-on:click="deleteView(saved.id, saved.name, false)" v-if="saved.isOwner"
                    class="cursor-pointer savedViewBtn">
                    <i class="fas fa-times"></i>
                  </div>
                  <div v-on:click="bookmarkview(null, saved.id, false, false)" v-if="!saved.issel"
                    class="cursor-pointer savedViewBtn savedViewBtn2">
                    <svg class="svg-inline--fa fa-bookmark myfaBtn" data-v-63cdf364=""
                      style="border: none !important; height: 14px; width: 14px; padding: 0px; margin: 0px;"
                      aria-hidden="true" focusable="false" data-prefix="far" data-icon="bookmark" role="img"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
                      <path fill="currentColor"
                        d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z">
                      </path>
                    </svg>
                  </div>
                  <div v-on:click="rename_view(saved.id, saved.name)" v-if="saved.isOwner"
                    class="cursor-pointer savedViewBtn savedViewBtn1">
                    <i class="fas fa-retweet"></i>
                  </div>
                </div>
                <div class="myBoxShadow mySaved cursor-pointer" style="margin: 20px 6px;"
                  :class="{ 'isSel': saved.issel }" v-on:click="mySavedViewClick($event, saved.id, saved.name, index)">
                  <div class="text-ellipsis" style="padding-left: 30px;">{{ saved.name }}</div>
                </div>
                <div class="viewIconSub" :aria-label="'Created By: ' + saved.user_id" data-balloon-pos="up-left">
                  <span v-if="saved.isOwner">O</span>
                  <span v-if="!saved.isOwner">S</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="!savedSettings.length > 0">
            <div class="col-12">
              <h5 class="secondaryTxt"><u><i class="far fa-gem"></i>Pinned Views</u></h5>
              You haven't pinned any views, so you can either create your own view or click
              <span v-on:click="getViewList(true)">
                <a class="primaryTxt cursor-pointer KDtxt">All Views List</a>
              </span>
              to see views created by others
            </div>
          </div>
        </div>
      </div>
      <div class="mr20top col-12" style="margin: 10px 0;">
        <div>
          <div class="tabsA">
            <div class="tabA">
              <input type="checkbox" id="chck2" class="inputA" v-model="isadvSets">
              <label class="tabA-label splCase" for="chck2">
                <div>
                  View Settings
                  <small style="font-weight: 100;word-spacing: 2px;font-style: italic;color: grey;">
                    (Analyzing data from {{ dispstartdt }} to {{ dispenddt }} in {{ timeZone.value }},
                    <span class="" v-if="AnalysisOp"> focusing on '{{ AnalysisOp.name }}' and '{{ l2dispname }}'</span>
                    <span v-show="portlevels.length != 0"> filtered by
                      <span v-for="(filter, index) in portlevels" :key="filter">
                        {{ filter.filterDisp }}({{ filter.filter_vals.length == 0 ? 'All' : filter.filter_vals.length }})
                        {{ index == portlevels.length - 1 ? '' : ',' }}
                      </span>
                    </span>.)
                  </small>
                </div>
              </label>
              <div class="tabA-content tabAddSets">
                <div class="row panel-card datelin">
                  <div class="col-12 col-md-6 col-lg-6 mb-3" v-show="enableDayRange">
                    <div class="radio-btn mb-3">
                      <input class="form-check-input me-2" type="radio" name="flexRadioDefault" id="ddateRange" checked
                        @change="choosRange = true">
                      <label class="form-check-label" for="ddateRange">
                        Choose Date Range
                      </label>
                    </div>
                    <div class="row" :style="choosRange ? '' : 'opacity:0.4'">
                      <div class="col-6">
                        <div>
                          <label for="startdt">
                            Start Date :
                          </label>
                          <span class="myfaBtn cursor-pointer tooltip-ins" v-on:click="resetDate(0); setDirty('startdt');"
                            v-show="choosRange">
                            <font-awesome-icon :icon="['fas', 'undo']" />
                            <span class="tooltiptext">{{ initialStart }}</span>
                          </span>
                          <div class="input-group datinpwd mr10top">
                            <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="startdt"
                              :enableTimePicker="false" @update:model-value="setDirty('startdt');" format="dd-MMM-yyyy"
                              class="w-100" :disabled="!choosRange" />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div>
                          <label for="enddt">
                            End Date :
                          </label>
                          <span class="myfaBtn cursor-pointer tooltip-ins" v-on:click="resetDate(1); setDirty('enddt');"
                            v-show="choosRange">
                            <font-awesome-icon :icon="['fas', 'undo']" />
                            <span class="tooltiptext">{{ initialEnd }}</span>
                          </span>
                          <div class="input-group datinpwd mr10top">
                            <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="enddt" format="dd-MMM-yyyy"
                              @update:model-value="setDirty('startdt')" :enableTimePicker="false" class="w-100"
                              :disabled="!choosRange" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 mb-3" v-show="enableDayRange">
                    <div class="radio-btn mb-3">
                      <input class="form-check-input me-2" type="radio" name="flexRadioDefault" id="dayRange"
                        @change="choosRange = false">
                      <label class="form-check-label" for="dayRange">
                        Choose Day Range
                      </label>
                    </div>
                    <div :style="!choosRange ? '' : 'opacity:0.4'">
                      <label for="dayRangeNumber">
                        Day Range :
                      </label>
                      <div class="input-group datinpwd mr10top">
                        <input type="number" class="form-control" v-model="daysRange" id="dayRangeNumber" placeholder="90"
                          :disabled="choosRange">
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-8 mb-3" v-show="!enableDayRange">
                    <div class="row">
                      <div class="col-6">
                        <div>
                          <label for="startdt">
                            Start Date :
                          </label>
                          <span class="myfaBtn cursor-pointer tooltip-ins" v-on:click="resetDate(0); setDirty('startdt');">
                            <font-awesome-icon :icon="['fas', 'undo']" />
                            <span class="tooltiptext">{{ initialStart }}</span>
                          </span>
                          <div class="input-group datinpwd mr10top">
                            <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="startdt"
                              :enableTimePicker="false" @update:model-value="setDirty('startdt');" format="dd-MMM-yyyy"
                              class="w-100"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div>
                          <label for="enddt">
                            End Date :
                          </label>
                          <span class="myfaBtn cursor-pointer tooltip-ins" v-on:click="resetDate(1); setDirty('enddt');">
                            <font-awesome-icon :icon="['fas', 'undo']" />
                            <span class="tooltiptext">{{ initialEnd }}</span>
                          </span>
                          <div class="input-group datinpwd mr10top">
                            <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="enddt" format="dd-MMM-yyyy" @update:model-value="setDirty('startdt')" :enableTimePicker="false" class="w-100"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 mb-3">
                    <label for="enddt">
                      Time Zone :
                    </label>
                    <VueMultiselect class="mymultiselect  hide-on-presentation  mr10top" openDirection="bottom" v-model="timeZone"
                      :options="timeZoneArr" track-by="value" label="value" :custom-label="customLabel" selectLabel=""
                      @select="setDirty('timeZone')" :show-labels="false" :multiple="false" :close-on-select="true" />
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 mb-3">
                    <label for="startdt">
                      First Level Analysis :
                    </label>
                    <VueMultiselect class="mymultiselect  hide-on-presentation  mr10top" openDirection="bottom" v-model="AnalysisOp"
                      :options="AnalysisOns" :multiple="false" :allow-empty="false" deselect-label="can't Deselect"
                      :close-on-select="true" @select="setDirty('AnalysisOp')" placeholder="Pick" track-by="name"
                      label="name" selectLabel="">
                      <template v-slot:singlelabel="{ value }">
                        <div class="multiselect-single-label">
                          {{ value.name }}
                        </div>
                      </template>
                      <template v-slot:option="{ option }">
                        <b>{{ option.name }}</b><br />
                        <small class="text-muted1" style="font-weight: 1000;">
                          Fill: {{ option.fillVal }}% &nbsp; Unq. Val(s):{{ option.uniqueVal }}
                        </small>
                      </template>
                    </VueMultiselect>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 mb-3">
                    <label>Second Level Analysis : </label>
                    <VueMultiselect class="mymultiselect  hide-on-presentation  input-group mr10top" openDirection="bottom"
                      v-model="ins_priorLv2op" :options="AnalysisOns" :multiple="false" :allow-empty="false"
                      deselect-label="can't Deselect" :close-on-select="true" @select="setDirty('ins_priorLv2op')"
                      placeholder="Pick" track-by="name" selectLabel="" label="name">
                      <template v-slot:singlelabel="{ value }">
                        <div class="multiselect-single-label">
                          {{ value.name }}
                        </div>
                      </template>
                      <template v-slot:option="{ option }">
                        <b>{{ option.name }}</b><br />
                        <small class="text-muted1" style="font-weight: 1000;">
                          Fill: {{ option.fillVal }}% &nbsp; Unq. Val(s):{{ option.uniqueVal }}
                        </small>
                      </template>
                    </VueMultiselect>
                  </div>
                </div>
                <div class="panel-card" style="height:350px;">
                  <div class="row">
                    <div class="col-12">
                      <h4><label>Filters : </label></h4>
                    </div>
                    <div class="col-4" v-show="portlevels.length == 0">
                      <h6 class="fltpadd">Add Filters </h6>
                    </div>
                    <div class="col-8" v-show="portlevels.length == 0">
                      <button type="button" class="btn addBtn" v-on:click="modifyPortLvl(null, 2); setDirty('filterA');">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" style="margin-bottom: 200px;">
                      <div class="row mr10top" v-for="(addfilters, index) in portlevels" :key="addfilters">
                        <div class="col-2">
                          <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="addfilters.filter_key"
                            :options="getdropsdata" :multiple="false" :allow-empty="false" deselect-label="can't Deselect"
                            :close-on-select="true" selectLabel="" deselectLabel=""
                            @close="loadPortVals(addfilters.filter_key, index); setDirty('filter');" placeholder="Pick"
                            track-by="name" label="name">
                            <template v-slot:singlelabel="{ value }">
                              <div class="multiselect-single-label">
                                {{ value.name }}
                              </div>
                            </template>
                            <template v-slot:option="{ option }">
                              <b>{{ option.name }}</b><br />
                              <small class="text-muted1" style="font-weight: 1000;">
                                Fill: {{ option.fillVal }}% &nbsp; Unq. Val(s):{{ option.uniqueVal }}
                              </small>
                            </template>
                          </VueMultiselect>
                        </div>
                        <div class="col-7 filterSelect">
                          <VueMultiselect class="mymultiselect  hide-on-presentation  form-control selectPriority multiselect"
                            openDirection="bottom" v-model="addfilters.filter_vals" :options="addfilters.filter_ops"
                            :multiple="true" selectGroupLabel="Select All" group-values="valF" group-label="header"
                            :group-select="true" :close-on-select="false" deselectGroupLabel="Unselect All"
                            @select="setDirty('filterD')" placeholder="Pick" track-by="val" label="val" selectLabel=""
                            :custom-label="customLabelFilter" />
                        </div>
                        <div class="col-2 text-end">
                          <div class="btn-group" role="group" aria-label="...">
                            <button type="button" class="btn minusBtn"
                              v-on:click="modifyPortLvl(index, 1); setDirty('filterM');">
                              <font-awesome-icon :icon="['fas', 'fa-minus']"></font-awesome-icon>
                            </button>
                            <button type="button" class="btn addBtn mar10lft"
                              :disabled="!(index == portlevels.length - 1) || index > 4"
                              v-on:click="modifyPortLvl(index, 0); setDirty('filterA');" style="margin-left: 10px;">
                              <font-awesome-icon :icon="['fas', 'fa-plus']"></font-awesome-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane col-12" v-show="loneshow">
        <div v-show="isInsOn" class="container-fluid">
          <div class="row content-panel port-content">
            <div class="col-6">
              <div class="backg">
                <div class="planet">
                  <div class="r1"></div>
                  <div class="r2"></div>
                  <div class="r3"></div>
                  <div class="r4"></div>
                  <div class="r5"></div>
                  <div class="r6"></div>
                  <div class="r7"></div>
                  <div class="r8"></div>
                  <div class="shad"></div>
                </div>
                <div class="stars">
                  <div class="s1"></div>
                  <div class="s2"></div>
                  <div class="s3"></div>
                  <div class="s4"></div>
                  <div class="s5"></div>
                  <div class="s6"></div>
                </div>
                <div class="an">
                  <div class="tank"></div>
                  <div class="astro">
                    <div class="helmet">
                      <div class="glass">
                        <div class="shine"></div>
                      </div>
                    </div>
                    <div class="dress">
                      <div class="c">
                        <div class="btn1"></div>
                        <div class="btn2"></div>
                        <div class="btn3"></div>
                        <div class="btn4"></div>
                      </div>
                    </div>
                    <div class="handl">
                      <div class="handl1">
                        <div class="glovel">
                          <div class="thumbl"></div>
                          <div class="b2"></div>
                        </div>
                      </div>
                    </div>
                    <div class="handr">
                      <div class="handr1">
                        <div class="glover">
                          <div class="thumbr"></div>
                          <div class="b1"></div>
                        </div>
                      </div>
                    </div>
                    <div class="legl">
                      <div class="bootl1">
                        <div class="bootl2"></div>
                      </div>
                    </div>
                    <div class="legr">
                      <div class="bootr1">
                        <div class="bootr2"></div>
                      </div>
                    </div>
                    <div class="pipe">
                      <div class="pipe2">
                        <div class="pipe3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="portalertbx">
                <div class="alert alert-warning">Sorry ! Could not Run analysis due to very less Ticket Count ("&lt;!
                  50").
                  Kindly Try changing the Time Period or filters to Analyse Insights </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row myWrapperMsg" v-show="showWrapper">
          <div class="col-sm-12">
            <h4>
              Settings have changed, so kindly click on <span class="uSpl" v-on:click="undoSetting()">"Undo
                Changes"</span> or <span class="uSpl" v-on:click="getAnalyse(1)">"Analyse"</span> to view the Dashboard
              and Insights.
            </h4>
          </div>
        </div>
        <div class="wrapperFun" :class="{ 'BlurClassIns': showWrapper || savePopShow }" v-show="!isInsOn">
          <div v-show="tempLoaderShow" class="tempLoaderDiv"></div>
          <div v-show="filterPopShow" class="filterDiv"></div>
          <div v-show="!isInsOn" class="dmain">
            <div id="dtabs">
              <div class="segmented-control spl" role="group" :class="myTabWidthH" style="box-shadow: none">
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 7 }"
                  v-on:click="chartVisbility(7)">
                  <font-awesome-icon icon="fa-solid fa-object-group" />&nbsp;Portfolio View
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == -1 }"
                  v-on:click="chartVisbility(-1)">
                  <font-awesome-icon icon="fa-solid fa-flask-vial" />&nbsp;Key Insights
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 0 }"
                  v-on:click="chartVisbility(0)">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Overall
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 1 }"
                  v-on:click="chartVisbility(1)">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Incoming
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 2 }"
                  v-on:click="chartVisbility(2); get_prior = 'All';" tooltip-enable="getCard.Resp_Tic_count == 'Nodata'"
                  v-show="getCard.Resp_Tic_count != 'Nodata'">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Ack. Time
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 3 }"
                  v-on:click="chartVisbility(3); get_prior = 'All';" v-show="getCard.Resol_Tic_Count != 'Nodata'">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Resln. Time
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 4 }"
                  v-on:click="chartVisbility(4); get_prior = 'All';" v-show="getCard.Reopen_Tic_count != 'Nodata'">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Reopen
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 5 }"
                  v-on:click="chartVisbility(5); get_prior = 'All';" v-show="getCard.Reassign_Tic_count != 'Nodata'">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Reassign
                </a>
                <a class="grpBtn2 grpBtnC" style="display:none"
                  :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 6 }"
                  v-on:click="chartVisbility(6)">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Converged
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 8 }"
                  v-on:click="chartVisbility(8)">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;Change
                </a>
                <a class="grpBtn2 grpBtnC" :class="{ 'blurscrCrd disablClks': wgtTypeload, 'themeclr': tabsel == 9 }"
                  v-on:click="chartVisbility(9)">
                  <font-awesome-icon icon="fa-solid fa-gauge-high" />&nbsp;DIY
                </a>
              </div>
            </div>
            <div id="dcontent" class="tab-contentV">
              <div class="row insSCardRo d-flex align-items-stretch g-3 "
                v-if="!isInsOn && !isTab1 && tabsel != 8 && tabsel != 9 && chartNo != 1"
                style="position: relative; z-index:1;">
                <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins"
                    v-show="selection == 0 || selection == 1 || selection == 6 || selection == 7">
                    <div class="boxC">
                      <div class="inner">
                        <h4 class="text-center">
                          {{ parseInt(KITic_Count).toLocaleString() }}
                        </h4>
                        <span class='secondaryTxt'>&nbsp;</span>
                      </div>
                      <div class="icon">
                        <font-awesome-icon :icon="['fas', 'fa-fingerprint']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">Ticket Count
                      </div>
                    </div>
                  </div>
                  <div class="card-quality myBoxShadow spl tooltip-ins"
                    v-show="selection == 2 || selection == 3 || selection == 4 || selection == 5">
                    <div class="boxC">
                      <div class="inner">
                        <h4 class="text-center">
                          {{ parseInt(FilterTic_Count).toLocaleString() }}
                        </h4>
                        <span class='secondaryTxt'>&nbsp;</span>
                      </div>
                      <div class="icon">
                        <font-awesome-icon :icon="['fas', 'fa-fingerprint']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">Ticket Count
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2" v-show="showPcards" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins" v-show="selection >= 0">
                    <div class="boxC">
                      <div class="inner" :class="{ 'blurscrCrd': p1_perc == 'Nodata' }">
                        <h4 class="text-center" v-show="p1_perc != 'Nodata'">
                          {{ p1_perc }}
                          <small>%</small>
                        </h4>
                        <span class='secondaryTxt' v-show="p1_Tic_count != 'Nodata'">&nbsp;{{
                          parseInt(p1_Tic_count).toLocaleString() }}</span>
                        <h4 class="text-center" v-show="p1_perc == 'Nodata'">
                          &nbsp;
                          <small>&nbsp;</small>
                        </h4>
                        <span class='secondaryTxt' v-show="p1_Tic_count == 'Nodata'">&nbsp;</span>
                      </div>
                      <div class="icon">
                        <font-awesome-icon :icon="['fas', 'fa-bomb']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">High Business Impact
                      </div>
                      <span class="tooltiptext" v-show="p1_perc == 'Nodata'">
                        High Business Impact % Score could not be generated due to missing not Mapping
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2" v-show="showReopenCard" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins">
                    <div class="boxC">
                      <div class="inner" :class="{ 'blurscrCrd': reopen_perc == 'Nodata' }">
                        <h4 class="text-center" v-show="reopen_perc != 'Nodata'">
                          {{ reopen_perc }}
                          <small>%</small>
                        </h4>
                        <span class='secondaryTxt' v-show="Reopen_Tic_count != 'Nodata'">&nbsp;{{
                          parseInt(Reopen_Tic_count).toLocaleString() }}</span>
                        <h4 class="text-center" v-show="reopen_perc == 'Nodata'">
                          <i class="fa-solid fa-ban"></i>
                          <small>&nbsp;</small>
                        </h4>
                        <span class='secondaryTxt' v-show="Reopen_Tic_count == 'Nodata'">&nbsp;</span>
                      </div>
                      <div class="icon" :class="{ 'blurscrCrd': reopen_perc == 'Nodata' }">
                        <font-awesome-icon :icon="['fas', 'fa-box-open']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">Reopened Tickets
                      </div>
                      <span class="tooltiptext" v-show="reopen_perc == 'Nodata'">
                        Reopen Score could not be generated due to missing 'Reopen Count' or incorrect mapping in the
                        source data.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2" v-show="showReassgCard" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins">
                    <div class="boxC">
                      <div class="inner" :class="{ 'blurscrCrd': Reassign_perc == 'Nodata' }">
                        <h4 class="text-center" v-show="Reassign_perc != 'Nodata'">
                          {{ Reassign_perc }}
                          <small>%</small>
                        </h4>
                        <span class='secondaryTxt' v-show="reassign_range_count != 'Nodata'">&nbsp;{{
                          parseInt(reassign_range_count).toLocaleString() }}</span>
                        <h4 class="text-center" v-show="Reassign_perc == 'Nodata'">
                          <i class="fa-solid fa-ban"></i>
                          <small>&nbsp;</small>
                        </h4>
                        <span class='secondaryTxt' v-show="reassign_range_count == 'Nodata'">&nbsp;</span>
                      </div>
                      <div class="icon" :class="{ 'blurscrCrd': Reassign_perc == 'Nodata' }">
                        <font-awesome-icon :icon="['fas', 'fa-random']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">
                        Atleast Two Hops
                      </div>
                      <span class="tooltiptext" v-show="Reassign_perc == 'Nodata'">
                        Reassigned Score could not be generated due to missing 'Assignment Revised Count' or incorrect
                        mapping in the source data.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2" v-show="showRespCard" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins">
                    <div class="boxC">
                      <div class="inner" :class="{ 'blurscrCrd': Resp_perc == 'Nodata' }">
                        <h4 class="text-center" v-show="Resp_perc != 'Nodata'">
                          {{ Resp_perc }}
                          <small>%</small>
                        </h4>
                        <span class='secondaryTxt' v-show="Resp_adher_count != 'Nodata'">&nbsp;{{
                          parseInt(Resp_adher_count).toLocaleString() }}</span>
                        <h4 class="text-center" v-show="Resp_perc == 'Nodata'">
                          <i class="fa-solid fa-ban"></i>
                          <small>&nbsp;</small>
                        </h4>
                        <span class='secondaryTxt' v-show="Resp_adher_count == 'Nodata'">
                          &nbsp;</span>
                      </div>
                      <div class="icon" :class="{ 'blurscrCrd': Resp_perc == 'Nodata' }">
                        <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">Acknowledgement SLA Adherence
                      </div>
                      <span class="tooltiptext" v-show="Resp_perc == 'Nodata'">
                        Acknowledgement(Response) SLA Adherence Score could not be generated due to missing 'Response
                        SLA Met' or incorrect mapping in the source data.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2" v-show="showResolCard" data-aos="flip-up" data-aos-once="true">
                  <div class="card-quality myBoxShadow spl tooltip-ins">
                    <div class="boxC">
                      <div class="inner" :class="{ 'blurscrCrd': Resol_perc == 'Nodata' }">
                        <h4 class="text-center" v-show="Resol_perc != 'Nodata'">
                          {{ Resol_perc }}
                          <small>%</small>
                        </h4>
                        <h4 class="text-center" v-show="Resol_perc == 'Nodata'">
                          <i class="fa-solid fa-ban"></i>
                          <small>&nbsp;</small>
                        </h4>
                        <span class='secondaryTxt' v-show="Resol_adher_count != 'Nodata'">&nbsp;{{
                          parseInt(Resol_adher_count).toLocaleString() }}</span>
                        <span class='secondaryTxt' v-show="Resol_adher_count == 'Nodata'">&nbsp;</span>
                      </div>
                      <div class="icon" :class="{ 'blurscrCrd': Resol_perc == 'Nodata' }">
                        <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                      </div>
                      <div class="card-quality-footer text-ellipsis">Resolution SLA Adherence</div>
                      <span class="tooltiptext" v-show="Resol_perc == 'Nodata'">
                        Resolution SLA Adherence Score could not be generated due to missing 'Resolution SLA Met' or
                        incorrect mapping in the source data.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="isTab1">
                <div class="text-end" v-if="!showfooterPDF">
                  <a class="effect btn-download thin eff-xl" v-on:click="export2PDF()">
                    Export Key Insights as PDF
                  </a>
                </div>
                <div style="position: relative;" v-show="showfooterPDF">
                  <img src="../assets/images/introS.png" style="height: 1000px;" />
                  <div style="position: absolute; bottom: 50px; right: 0;">
                    <h3 class="primaryTxt">Presenting analysis for : </h3>
                    <h3 class="secondaryTxt">{{ loadedView }}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 col-lg-2">
                    <div class="card-quality myBoxShadow spl tooltip-ins ">
                      <div class="boxC">
                        <div class="inner">
                          <h4 class="text-center">
                            {{ parseInt(KITic_Count).toLocaleString() }}
                          </h4>
                          <span class='secondaryTxt'>&nbsp;</span>
                        </div>
                        <div class="icon">
                          <font-awesome-icon :icon="['fas', 'fa-fingerprint']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">Ticket Count
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                    <div class="card-quality myBoxShadow spl tooltip-ins">
                      <div class="boxC">
                        <div class="inner" :class="{ 'blurscrCrd': p1_perc == 'Nodata' }">
                          <h4 class="text-center" v-show="p1_perc != 'Nodata'">
                            {{ p1_perc }}
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="p1_perc == 'Nodata'">
                            <i class="fa-solid fa-ban"></i>
                            <small>&nbsp;</small>
                          </h4>
                          <span class='secondaryTxt' v-show="p1_perc != 'Nodata'">
                            &nbsp;{{ parseInt(p1_Tic_count).toLocaleString() }}</span>
                          <span class='secondaryTxt' v-show="p1_perc == 'Nodata'">
                            &nbsp;</span>
                        </div>
                        <div class="icon" :class="{ 'blurscrCrd': keyInsCard.p1_perc == 'Nodata' }">
                          <font-awesome-icon :icon="['fas', 'fa-bomb']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">High Business Impact
                        </div>
                        <span class="tooltiptext" v-show="p1_perc == 'Nodata'">
                          High Business Impact % Score could not be generated due to missing not Mapping
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                    <div class="card-quality myBoxShadow spl tooltip-ins">
                      <div class="boxC">
                        <div class="inner" :class="{ 'blurscrCrd': keyInsCard.reopen_perc == 'Nodata' }">
                          <h4 class="text-center" v-show="keyInsCard.reopen_perc >= 1">
                            {{ keyInsCard.reopen_perc }}
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="keyInsCard.reopen_perc < 1">
                            &lt; 1
                            <small>%</small>
                          </h4>
                          <h4 v-show="keyInsCard.reopen_perc == 'Nodata'">
                            <i class="fa-solid fa-ban"></i>
                          </h4>
                          <span class='secondaryTxt' v-show="keyInsCard.Reopen_Tic_count != 'Nodata'">
                            &nbsp;{{ parseInt(keyInsCard.Reopen_Tic_count).toLocaleString() }}
                          </span>
                          <span class='secondaryTxt' v-show="keyInsCard.Reopen_Tic_count == 'Nodata'">
                            &nbsp;
                          </span>
                        </div>
                        <div class="icon" :class="{ 'blurscrCrd': keyInsCard.reopen_perc == 'Nodata' }">
                          <font-awesome-icon :icon="['fas', 'fa-box-open']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">Reopened Tickets</div>
                        <span class="tooltiptext" v-show="keyInsCard.reopen_perc == 'Nodata'">
                          Reopen Score could not be generated due to missing 'Reopened Count' or incorrect mapping in
                          the source data.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                    <div class="card-quality myBoxShadow spl tooltip-ins">
                      <div class="boxC">
                        <div class="inner" :class="{ 'blurscrCrd': keyInsCard.Reassign_perc == 'Nodata' }">
                          <h4 class="text-center" v-show="keyInsCard.Reassign_perc >= 1">
                            {{ keyInsCard.Reassign_perc }}
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="keyInsCard.Reassign_perc < 1">
                            &lt; 1
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="keyInsCard.Reassign_perc == 'Nodata'">
                            <i class="fa-solid fa-ban"></i>
                          </h4>
                          <span class='secondaryTxt' v-show="keyInsCard.Reassign_perc != 'Nodata'">
                            &nbsp;{{ parseInt(keyInsCard.Reassign_Tic_count).toLocaleString() }}
                          </span>
                          <span class='secondaryTxt' v-show="keyInsCard.Reassign_perc == 'Nodata'">
                            &nbsp;
                          </span>
                        </div>
                        <div class="icon" :class="{ 'blurscrCrd': keyInsCard.Reassign_perc == 'Nodata' }">
                          <font-awesome-icon :icon="['fas', 'fa-random']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">Atleast Two Hops</div>
                        <span class="tooltiptext" v-show="keyInsCard.Reassign_perc == 'Nodata'">
                          Reassigned Score could not be generated due to missing 'Assignment Revised Count' or incorrect
                          mapping in the source data.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                    <div class="card-quality myBoxShadow spl tooltip-ins">
                      <div class="boxC">
                        <div class="inner" :class="{ 'blurscrCrd': keyInsCard.Resp_adher == 'Nodata' }">
                          <h4 class="text-center" v-show="keyInsCard.Resp_adher != 'Nodata'">
                            {{ keyInsCard.Resp_adher }}
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="keyInsCard.Overall_Resp_adher_count < 1">
                            <small>%</small>
                          </h4>
                          <h4 v-show="keyInsCard.Resp_adher == 'Nodata'">
                            <i class="fa-solid fa-ban"></i>
                          </h4>
                          <span class='secondaryTxt' v-show="keyInsCard.Resp_adher != 'Nodata'">
                            &nbsp;{{ parseInt(keyInsCard.Overall_Resp_adher_count).toLocaleString() }}
                          </span>
                          <span class='secondaryTxt' v-show="keyInsCard.Resp_adher == 'Nodata'">
                            &nbsp;
                          </span>
                        </div>
                        <div class="icon" :class="{ 'blurscrCrd': keyInsCard.Resp_adher == 'Nodata' }">
                          <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">Acknowledgement SLA Adherence
                        </div>
                        <span class="tooltiptext" v-show="keyInsCard.Resp_adher == 'Nodata'">
                          Acknowledgement(Response) SLA Adherence Score could not be generated due to missing 'Response
                          SLA Met' or incorrect mapping in the source data.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                    <div class="card-quality myBoxShadow spl tooltip-ins">
                      <div class="boxC">
                        <div class="inner" :class="{ 'blurscrCrd': keyInsCard.Resol_adher == 'Nodata' }">
                          <h4 class="text-center" v-show="keyInsCard.Resol_adher != 'Nodata'">
                            {{ keyInsCard.Resol_adher }}
                            <small>%</small>
                          </h4>
                          <h4 class="text-center" v-show="keyInsCard.Overall_Resol_adher_count < 1">
                            <small>%</small>
                          </h4>
                          <h4 v-show="keyInsCard.Resol_adher == 'Nodata'">
                            <i class="fa-solid fa-ban"></i>
                          </h4>
                          <span class='secondaryTxt' v-show="keyInsCard.Resol_adher != 'Nodata'">
                            &nbsp;{{ parseInt(keyInsCard.Overall_Resol_adher_count).toLocaleString() }}
                          </span>
                          <span class='secondaryTxt' v-show="keyInsCard.Resol_adher == 'Nodata'">&nbsp;</span>
                        </div>
                        <div class="icon" :class="{ 'blurscrCrd': keyInsCard.Resol_adher == 'Nodata' }">
                          <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                        </div>
                        <div class="card-quality-footer text-ellipsis">Resolution SLA Adherence
                        </div>
                        <span class="tooltiptext" v-show="keyInsCard.Resol_adher == 'Nodata'">
                          Resolution SLA Adherence Score could not be generated due to missing 'Resolution SLA Met' or
                          incorrect mapping in the source data.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="keydrive" class="row" style="margin-top: 30px;" id="sectionHolder">
                  <div v-for="(InsHead, index) in keydrive" :key="InsHead" style="margin-bottom: 20px;">
                    <div class="cardR">
                      <div class="boxR">
                        <div class="myZoomClass">
                          <div class="content-panel1 myObs" :class="InsHead.key_ins == 'Nodata' ? 'smallD' : ''">
                            <h2 class="chartTitle themeclr2" style="top: -20px;">{{ InsHead.Ins_hdr }}</h2>
                            <div class="panel-body" style="position: relative;top: -25px;">
                              <div class="row">
                                <div class="col-12 loader-inkeys " v-show="!InsHead.isLoadKeyDim">
                                  <widgetLoadingComp></widgetLoadingComp>
                                </div>
                                <div class="col-12 col-lg-6"
                                  v-if="InsHead.key_ins != 'Error' && InsHead.key_ins != 'Nodata'">
                                  <div class="row">
                                    <div class="col-12 overflow-hidden" style="position: relative;">
                                      <div id="Chart0" class="dimChart" v-if="InsHead.dimcond == 0"></div>
                                      <div id="Chart1" class="dimChart" v-if="InsHead.dimcond == 1"></div>
                                      <div id="Chart2" class="dimChart" v-if="InsHead.dimcond == 2"></div>
                                      <div id="Chart3" class="dimChart" v-if="InsHead.dimcond == 3">
                                        <table class="table-striped Striped-font thmHead mttrTbl1">
                                          <tbody>
                                            <tr class="themeclr2 row">
                                              <th class="text-center col-3">
                                                Request Priority
                                              </th>
                                              <th v-if="isslaadherence" class="text-center col-3">
                                                SLA Adhereance
                                              </th>
                                              <th class="text-end" :class="isslaadherence ? 'col-4' : 'col-6'">
                                                MTTA
                                              </th>
                                              <th class="text-end" :class="isslaadherence ? 'col-2' : 'col-3'">
                                                # Tickets
                                              </th>
                                            </tr>
                                            <tr v-for="(dataV, index) in mttadata" v-bind:key="dataV" class="row">
                                              <td v-on:click="onTickets(dataV.Request_Priority, 0)" class="col-3">
                                                <span class="uSpl">{{ dataV.Request_Priority }}</span>
                                              </td>
                                              <td class="text-end col-3" v-if="isslaadherence && dataV.slaadherence != '-'">
                                                {{ dataV.slaadherence.toFixed(1) }} <small>%</small>
                                                <div style="height: 25px; display: inline-block;margin-left: 5px;"
                                                  :id="'mttaA' + index">
                                                </div>
                                              </td>
                                              <td class="text-end" :class="isslaadherence ? 'col-4' : 'col-6'">
                                                {{ convert2ddhhmm(dataV.Mttr, 'M') }}
                                                <div style="height: 25px; display: inline-block;margin-left: 5px;"
                                                  :id="'mttaV' + index">
                                                </div>
                                              </td>
                                              <td class="text-end" :class="isslaadherence ? 'col-2' : 'col-3'">
                                                {{ dataV.PriorityCount.toLocaleString() }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div id="Chart4" class="dimChart" v-if="InsHead.dimcond == 4"
                                        style="overflow-y: auto;">
                                        <table class="table-striped Striped-font thmHead mttrTbl1">
                                          <tbody>
                                            <tr class="themeclr2 row">
                                              <th class="text-center col-3">
                                                Request Priority
                                              </th>
                                              <th v-if="isslaadherence" class="text-center col-3">
                                                SLA Adhereance
                                              </th>
                                              <th class="text-end" :class="isslaadherence ? 'col-4' : 'col-6'">
                                                MTTR
                                              </th>
                                              <th class="text-end" :class="isslaadherence ? 'col-2' : 'col-3'">
                                                # Tickets
                                              </th>
                                            </tr>
                                            <tr v-for="(dataV, index) in mttrdata" v-bind:key="dataV" class="row">
                                              <td v-on:click="onTickets(dataV.Request_Priority, 1)" class="col-3">
                                                <span class="uSpl">{{ dataV.Request_Priority }}</span>
                                              </td>
                                              <td class="text-end col-3" v-if="isslaadherence && dataV.slaadherence != '-'">
                                                {{ dataV.slaadherence.toFixed(1) }} <small>%</small>
                                                <div style="height: 25px; display: inline-block;margin-left: 5px;"
                                                  :id="'mttrA' + index">
                                                </div>
                                              </td>
                                              <td class="text-end" :class="isslaadherence ? 'col-4' : 'col-6'">
                                                {{ convert2ddhhmm(dataV.Mttr, 'M') }}
                                                <div style="height: 25px; display: inline-block;margin-left: 5px;"
                                                  :id="'mttrV' + index">
                                                </div>
                                              </td>
                                              <td class="text-end" :class="isslaadherence ? 'col-2' : 'col-3'">
                                                {{ dataV.PriorityCount.toLocaleString() }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div id="Chart5" class="dimChart" v-if="InsHead.dimcond == 5"></div>
                                      <div id="Chart6" class="dimChart" v-if="InsHead.dimcond == 6"></div>
                                      <div id="Chart7" class="dimChart" v-if="InsHead.dimcond == 7">
                                      </div>
                                      <div id="Chart8" class="dimChart" v-if="InsHead.dimcond == 8">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 col-lg-6"
                                  v-if="InsHead.key_ins != 'Error' && InsHead.key_ins != 'Nodata'">
                                  <div class="row" v-show="!showfooterPDF">
                                    <div class="col-6">
                                      <a class="effect btn-expand thin eff-md" v-on:click="myExpandIns(InsHead.key_ins)">
                                        Expand All
                                      </a>
                                      <a class="effect btn-collapse thin eff-md"
                                        v-on:click="myCollapseIns(InsHead.key_ins)" style="margin-left:10px;">
                                        Collapse All
                                      </a>
                                    </div>
                                    <div class="col-6 text-end">
                                      <a class="effect btn-download thin eff-md" v-on:click="downKeyIns(InsHead)">
                                        Export
                                      </a>
                                    </div>
                                  </div>
                                  <div class="bulletList" v-bind:id="'topIssId' + index" v-if="InsHead.key_ins"
                                    :ref="'topIss' + index">
                                    <ul v-for="(keyIns, inspos) in InsHead.key_ins" :key="keyIns">
                                      <li>
                                        <div class="show-data">
                                          <div class="tabB" style="margin-bottom: 10px;">
                                            <input type="checkbox" :id="'ins-' + keyIns.id" class="inputA">
                                            <label class="tabB-label" :for="'ins-' + keyIns.id">{{ keyIns.name }}</label>
                                            <div class="tabB-content">
                                              <div class="row" style="margin: 0;padding: 0;">
                                                <div class="col-12">
                                                  <ul style=" padding: 5px; margin: 0px;" class="bulletList">
                                                    <li v-for="(keyInsIndiv, optVal) in keyIns.values" :key="keyInsIndiv"
                                                      v-html="replaceBar(keyInsIndiv, index, inspos, optVal)">
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div class="col-12"
                                  v-if="InsHead.key_ins == 'Nodata' || InsHead.chartNoData != undefined">
                                  <div class="text-center">
                                    <div class="row">
                                      <div class="col-lg-2 col-2">
                                        <div class="level _10x10">
                                          <div class="level _8x8">
                                            <div class="level _6x6">
                                              <div class="level _4x4">
                                                <div class="level _2x2">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-lg-10 col-10 text-start text-danger" style="margin:auto;">
                                        {{ InsHead.desc }} <span v-if="InsHead.chartNoData != undefined">
                                          {{ InsHead.chartNoData }}.</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h6 style="margin-top: 50px;" v-show="showfooterPDF" class="primaryTxt text-center">
                  <img src="../assets/images/LTIM.png" style="float:left;" />
                  Analysis generated using <b>OPSight</b>
                </h6>
              </div>
              <div id="portfolioSnap" v-if="chartNo == 1">
                <div class="cardR p-0">
                  <div class="boxR myZoomClass " id="portfolioSnapInner" :class="$store.state.TClrs">
                    <div class="content-panel1">
                      <div class="myZoomClass">
                        <div class="insideL  hide-on-presentation ">
                          <div class="icon">
                            <font-awesome-icon icon="fa-solid fa-bars" />
                          </div>
                          <div class="contents">
                            <span>
                              <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" v-on:click="addToSlider()"
                                title="Add to Storyboard" />
                              <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                v-on:click="downloadPort()" />
                            </span>
                          </div>
                        </div>
                        <div class="insideR hide-on-presentation">
                          <div class="icon">
                            <font-awesome-icon icon="fa-solid fa-info" />
                          </div>
                          <div class="contents">
                            This view gives you ability to see portfolio hotspot w.r.t ticket split and MTTR. You can
                            change the parameters using the dropdown and click on generate porfolio to see the
                            hotspots. Click on individual box to get more insights.<br /><br />
                            Actions you can take on this widget: <br />
                            <ul>
                              <li>Click on
                                <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" />
                                to add to storyboard
                              </li>
                              <li>Click on
                                <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" />
                                to download the chart with current insight
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="p-2">
                        <div class="row" style="position: relative; z-index:1;">
                          <div class="col-4 col-lg-2" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom"
                              v-show="selection == 0 || selection == 1 || selection == 6 || selection == 7">
                              <div class="boxC">
                                <div class="inner">
                                  <h4 class="text-center">
                                    {{ parseInt(KITic_Count).toLocaleString() }}
                                  </h4>
                                  <span class='secondaryTxt'>&nbsp;</span>
                                </div>
                                <div class="icon">
                                  <font-awesome-icon :icon="['fas', 'fa-fingerprint']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">Ticket Count
                                </div>
                              </div>
                            </div>
                            <div class="card-quality myBoxShadow spl tooltip-ins"
                              v-show="selection == 2 || selection == 3 || selection == 4 || selection == 5">
                              <div class="boxC">
                                <div class="inner">
                                  <h4 class="text-center">
                                    {{ parseInt(FilterTic_Count).toLocaleString() }}
                                  </h4>
                                  <span class='secondaryTxt'>&nbsp;</span>
                                </div>
                                <div class="icon">
                                  <font-awesome-icon :icon="['fas', 'fa-fingerprint']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">Ticket Count
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2" v-show="showPcards" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom"
                              tooltip-enable="p1_perc == 'Nodata'">
                              <div class="boxC">
                                <div class="inner" :class="{ 'blurscrCrd': p1_perc == 'Nodata' }">
                                  <h4 class="text-center" v-show="p1_perc != 'Nodata'">
                                    {{ p1_perc }}
                                    <small>%</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="p1_Tic_count != 'Nodata'">&nbsp;{{
                                    parseInt(p1_Tic_count).toLocaleString() }}</span>
                                  <h4 class="text-center" v-show="p1_perc == 'Nodata'">
                                    <i class="fa-solid fa-ban"></i>
                                    <small>&nbsp;</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="p1_Tic_count == 'Nodata'">&nbsp;</span>
                                </div>
                                <div class="icon">
                                  <font-awesome-icon :icon="['fas', 'fa-bomb']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">High Business Impact
                                </div>
                                <span class="tooltiptext" v-show="p1_perc == 'Nodata'">
                                  High Business Impact % Score could not be generated due to missing not Mapping
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2" v-show="showReopenCard" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom">
                              <div class="boxC">
                                <div class="inner" :class="{ 'blurscrCrd': reopen_perc == 'Nodata' }">
                                  <h4 class="text-center" v-show="reopen_perc != 'Nodata'">
                                    {{ reopen_perc }}
                                    <small>%</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Reopen_Tic_count != 'Nodata'">&nbsp;{{
                                    parseInt(Reopen_Tic_count).toLocaleString() }}</span>
                                  <h4 class="text-center" v-show="reopen_perc == 'Nodata'">
                                    <i class="fa-solid fa-ban"></i>
                                    <small>&nbsp;</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Reopen_Tic_count == 'Nodata'">&nbsp;</span>
                                </div>
                                <div class="icon" :class="{ 'blurscrCrd': reopen_perc == 'Nodata' }">
                                  <font-awesome-icon :icon="['fas', 'fa-box-open']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">
                                  Reopened Tickets
                                </div>
                                <span class="tooltiptext" v-show="reopen_perc == 'Nodata'">
                                  Reopen Score could not be generated due to missing 'Reopen Count' or incorrect mapping
                                  in the source data.
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2" v-show="showReassgCard" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom" uib-tooltip=""
                              tooltip-enable="Reassign_perc == 'Nodata'">
                              <div class="boxC">
                                <div class="inner" :class="{ 'blurscrCrd': Reassign_perc == 'Nodata' }">
                                  <h4 class="text-center" v-show="Reassign_perc != 'Nodata'">
                                    {{ Reassign_perc }}
                                    <small>%</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="reassign_range_count != 'Nodata'">&nbsp;{{
                                    parseInt(reassign_range_count).toLocaleString() }}</span>
                                  <h4 class="text-center" v-show="Reassign_perc == 'Nodata'">
                                    <i class="fa-solid fa-ban"></i>
                                    <small>&nbsp;</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="reassign_range_count == 'Nodata'">&nbsp;</span>
                                </div>
                                <div class="icon" :class="{ 'blurscrCrd': Reassign_perc == 'Nodata' }">
                                  <font-awesome-icon :icon="['fas', 'fa-random']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">Atleast Two Hops
                                </div>
                                <span class="tooltiptext" v-show="Reassign_perc == 'Nodata'">Reassigned Score could
                                  not be
                                  generated due to missing 'Assignment Revised Count' or incorrect mapping in the
                                  source
                                  data.</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2" v-show="showRespCard" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom">
                              <div class="boxC">
                                <div class="inner" :class="{ 'blurscrCrd': Resp_perc == 'Nodata' }">
                                  <h4 class="text-center" v-show="Resp_perc != 'Nodata'">
                                    {{ Resp_perc }}
                                    <small>%</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Resp_adher_count != 'Nodata'">&nbsp;{{
                                    parseInt(Resp_adher_count).toLocaleString() }}</span>
                                  <h4 class="text-center" v-show="Resp_perc == 'Nodata'">
                                    <i class="fa-solid fa-ban"></i>
                                    <small>&nbsp;</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Resp_adher_count == 'Nodata'">&nbsp;</span>
                                </div>
                                <div class="icon" :class="{ 'blurscrCrd': Resp_perc == 'Nodata' }">
                                  <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">Acknowledgement SLA Adherence
                                </div>
                                <span class="tooltiptext" v-show="Resp_perc == 'Nodata'">Acknowledgement(Response) SLA
                                  Adherence Score could not be generated due to missing 'Response SLA Met' or incorrect
                                  mapping in the source data.</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2" v-show="showResolCard" data-aos="flip-up" data-aos-once="true">
                            <div class="card-quality myBoxShadow spl tooltip-ins bottom" uib-tooltip=""
                              tooltip-enable="Resol_perc == 'Nodata'">
                              <div class="boxC">
                                <div class="inner" :class="{ 'blurscrCrd': Resol_perc == 'Nodata' }">
                                  <h4 class="text-center" v-show="Resol_perc != 'Nodata'">
                                    {{ Resol_perc }}
                                    <small>%</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Resol_perc != 'Nodata'">
                                    &nbsp;{{ parseInt(Resol_adher_count).toLocaleString() }}
                                  </span>
                                  <h4 class="text-center" v-show="Resol_perc == 'Nodata'">
                                    <i class="fa-solid fa-ban"></i>
                                    <small>&nbsp;</small>
                                  </h4>
                                  <span class='secondaryTxt' v-show="Resol_perc == 'Nodata'">
                                    &nbsp;
                                  </span>
                                </div>
                                <div class="icon" :class="{ 'blurscrCrd': Resol_perc == 'Nodata' }">
                                  <font-awesome-icon :icon="['fas', 'fa-stopwatch']"></font-awesome-icon>
                                </div>
                                <div class="card-quality-footer text-ellipsis">Resolution SLA Adherence
                                </div>
                                <span class="tooltiptext" v-show="Resol_perc == 'Nodata'">Resolution SLA Adherence
                                  Score
                                  could
                                  not be generated due to missing 'Resolution SLA Met' or incorrect mapping in the
                                  source
                                  data.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mySelection align-items-end hide-on-presentation">
                          <div class="col-12 col-lg-5 mb-2">
                            <label>Select Rows: </label>
                            <div class="input-group myMarginTop">
                              <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="catop"
                                :options="AnalysisOns" :multiple="false" :allow-empty="false" selectLabel=""
                                deselect-label="can't Deselect" :close-on-select="true" placeholder="Search Domain"
                                track-by="name" label="name" />
                            </div>
                          </div>
                          <div class="col-12 col-lg-5 mb-2">
                            <label>Select Columns: </label>
                            <div class="input-group myMarginTop x">
                              <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="splitop"
                                :options="AnalysisOns" :multiple="false" :allow-empty="false" selectLabel=""
                                deselect-label="can't Deselect" :close-on-select="true" placeholder="Search Domain"
                                track-by="name" label="name" />
                            </div>
                          </div>
                          <div class="col-lg-2 col-12 mb-2">
                            <div class="effect btn-generate mar30top hidePic hide-on-presentation w-100" v-on:click="genPortfolio()">
                              Generate Portfolio </div>
                          </div>
                        </div>
                        <div class="row">
                          <div v-if="!isportError" class="col-12 alert alert-danger porterrmg">
                            <b>Error!</b>
                            Something Went wrong in Generating Portfolio . Kindly try with Different Categories
                          </div>
                          <div class="col-12 text-end my-2 hidePic hide-on-presentation" v-if="isportError">
                            <div
                              style="display: inline-block;margin-right: 15px; align-items: center; display: inline-flex;">
                              <span style="margin-right: 5px;">Hide MTTR</span>
                              <input type="checkbox" class="switch_1 ms-1" step="margin-top:5px;"
                                v-model='portfolioMTTROverride' :disabled="!isMTTRPresent"
                                :class="{ 'plsDisable': !isMTTRPresent }">
                            </div>
                            <div
                              style="display: inline-block;margin-right: 10px;  align-items: center; display: inline-flex;">
                              <span style="margin-right: 5px;">Hide Blanks</span>
                              <input type="checkbox" class="switch_1 ms-1" step="margin-top:5px;" v-model='isRemoveBlank'
                                v-on:change="removePortBlank()">
                            </div>
                          </div>
                          <div class="col-12" v-if="isportError">
                            <suspense>
                              <div v-for="port in wholePortdata" :key="port">
                                <div class="course">
                                  <div class="col-4 col-lg-2" :title="port.category_head">
                                    <div style="padding: 0 0 0 5px;width: 90%;margin-left: 3%;">
                                      <div class="course-preview block-with-text row cursor-pointer"
                                        v-on:click="portClick(port.category_head, 0)">
                                        <h5 class="courseH3Sm text-ellipsis col-12">{{ port.category_head }}</h5>
                                        <div class="course-sub"
                                          :class="isMTTRPresent && !portfolioMTTROverride ? 'col-6' : 'col-12'"
                                          title="% Ticket">
                                          <div
                                            :class="port.category_per > 20 ? 'dangerClass position-relative' : 'position-relative'">
                                            <span class="subLbl">
                                              <font-awesome-icon :icon="['fas', 'fa-ticket']"></font-awesome-icon>
                                            </span>
                                            <span class="subVal">{{ port.category_per }}<small>%</small></span>
                                          </div>
                                        </div>
                                        <div class="course-sub col-6 " v-if="isMTTRPresent && !portfolioMTTROverride"
                                          title="MTTR">
                                          <div class="position-relative">
                                            <span class="subLbl">
                                              <font-awesome-icon :icon="['far', 'fa-clock']"></font-awesome-icon>
                                            </span>
                                            <span class="subVal" v-hrstodaysmod="{ val: port.category_mttr }"></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-10">
                                    <div class="container-fluid">
                                      <div class="row">
                                        <div class="col-4 col-lg-2 mb-1" v-for="subport in port.sub_list" :key="subport">
                                          <div style="padding:0px 5px">
                                            <div class="course-info block-with-text row cursor-pointer"
                                              v-on:click="portClick(port.category_head + '~' + subport.sub_name, 1)">
                                              <div class="course-supersub col-12">
                                                {{ subport.sub_name }}
                                              </div>
                                              <div class="course-sub"
                                                :class="isMTTRPresent && !portfolioMTTROverride ? 'col-6' : 'col-12'"
                                                title="% Ticket">
                                                <div
                                                  :class="subport.sub_per * port.category_per > 500 ? 'dangerClass position-relative' : 'position-relative'">
                                                  <span class="subVal">{{ subport.sub_per }}<small>%</small></span>
                                                </div>
                                              </div>
                                              <div class="course-sub col-6" v-if="isMTTRPresent && !portfolioMTTROverride"
                                                title="MTTR">
                                                <div
                                                  :class="parseInt(subport.sub_mttr) > parseInt(port.category_mttr) ? 'dangerClass position-relative' : 'position-relative'">
                                                  <span class="subVal" v-hrstodaysmod="{ val: subport.sub_mttr }"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </suspense>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row text-end" v-show="!isInsOn">
                <div class="col-12" v-show="showPriorityPatch">
                  <div class="segmented-control mr20top" role="group">
                    <div class="segmented-control_btn grpBtnC grpBtn3" :class="{ 'themeclr': prior_tab.ticked == true }"
                      v-for="(prior_tab, index) in prior_list" :key="prior_tab"
                      v-on:click="get_prior_sel(prior_tab.priority, index)">
                      {{ prior_tab.priority }}
                    </div>
                  </div>
                </div>
                <div class="col-12 fltrrangepos position-relative z-3" :class="showPriorityPatch ? 'col-12' : 'col-12'"
                  v-show="showFilterIcon">
                  <span>Filter Range: <b class="themeclr2">({{ slider.minValue.toLocaleString() }} -
                      {{ slider.maxValue.toLocaleString() }})</b></span>
                  <a class="themeclr2 filterIcon cursor-pointer" @click="fliterPopup.show()">
                    <i class="fas fa-filter"></i>
                  </a>
                </div>
              </div>
              <div class="row mt-2" v-if="chartNo == 2">
                <div class="myCustomCol mt-5" v-for="widgetitem in enabledWidget" :key="widgetitem"
                  :style="(widgetitem.wgt == 'HourlyTrend' || widgetitem.wgt == 'DailyTrend' || widgetitem.wgt == 'VarianceHeat') ? { 'max-width': '100%', 'flex': '0 0 100%' } : {}"
                  data-aos="fade-right" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                  <div>
                    <component :is="widgetitem.wgt" :tabname="tabName" :getpass="widgetitem.passdata"
                      :getPins="passpinInfo" @getKDrill="getKDrill" @explainModel="explainModel"> </component>
                  </div>
                </div>
              </div>
              <div v-if="chartNo == 3">
                <div class="row marbtm20">
                  <div class="col-12 text-center" style="margin: 4px 0 16px">
                    <div class="segmented-control chnage-tab-btn-group" role="group">
                      <div class="segmented-control_btn grpBtnC changeButton" v-on:click="drawChangeChart(1)">
                        Bump Chart View
                      </div>
                      <div class="segmented-control_btn grpBtnC changeButton" v-on:click="drawChangeChart(3)">
                        Waterfall View
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" data-aos="fade-right" data-aos-easing="ease-in-out" data-aos-mirror="true"
                    data-aos-once="true" data-aos-offset="-300">
                    <component :is="changedwgtTemp" :tabname="tabName" :getpass="changePassdata" :getPins="passpinInfo"
                      @getKDrill="getKDrill" id="changeSnap"> </component>
                  </div>
                </div>
              </div>
              <div v-if="chartNo == 4">
                <div class="row" style="margin: 10px 0">
                  <div class="col-12 text-center" style="margin: 4px 0 16x 0">
                    <div class="segmented-control chnage-tab-btn-group" role="group">
                      <div class="segmented-control_btn grpBtnC fancyButton" v-on:click="drawFancyChart(1)">
                        Drilldown View
                      </div>
                      <div class="segmented-control_btn grpBtnC fancyButton" v-on:click="drawFancyChart(2)">
                        Sankey View
                      </div>
                      <div class="segmented-control_btn grpBtnC fancyButton" v-on:click="drawFancyChart(5)">
                        Pivot View
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin: 10px 0 0 0">
                  <div class="col-12" data-aos="fade-right" data-aos-easing="ease-in-out" data-aos-mirror="true"
                    data-aos-once="true" data-aos-offset="-300">
                    <component :is="custview" :tabname="tabName" :getPins="passpinInfo" :getDrops="getdropsdata"
                      id="diySnap" @getKDrill="getKDrill">
                    </component>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-if="isadvSets" class="myAnalyzeBtnShow">
    <a class="effect btn-save eff-lg" v-on:click="undoSetting()" style="margin-right: 15px;" v-if="showWrapper">
      Undo Changes
    </a>
    <a class="effect btn-analyze eff-lg" role="button" v-on:click="getAnalyse(1)">
      Analyse
    </a>
    <a class="btn stdBtn btn-bordered myClse grpBtn" role="button" v-on:click="isadvSets = !isadvSets">
      Close Settings
    </a>
  </div>
</template>
<script>
var cond
var selectedId, selectedName, viewNameV, getcolumnprior
var insightInfo = {}
var enabledWidgetsLst = []
var port_nBlank = []
var changeOp, changeCC, changeCust
let geticondiv
var myChart0, myChart1, myChart2, myChart5, myChart6, myChart7, myChart8
var checkCount = [];
function reportWindowSizeKI() {
  let chartDomWC = document.getElementById('Chart0');
  if (chartDomWC != null && chartDomWC != undefined && chartDomWC.clientWidth > 0) {
    if (myChart0 != undefined) {
      myChart0.resize()
    }
    if (myChart1 != undefined) {
      myChart1.resize()
    }
    if (myChart2 != undefined) {
      myChart2.resize()
    }
    if (myChart5 != undefined) {
      myChart5.resize()
    }
    if (myChart6 != undefined) {
      myChart6.resize()
    }
    if (myChart7 != undefined) {
      myChart7.resize()
    }
    if (myChart8 != undefined) {
      myChart8.resize()
    }
  }
}
import {
  ref
} from 'vue';
import {
  useRoute
} from 'vue-router';
import moment from 'moment';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  Modal
} from 'bootstrap';
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import FileSaver from 'file-saver';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import draggable from 'vuedraggable'
import Sparkline from 'sparklines';
import html2pdf from 'html2pdf.js'
import widgetHolder from "../data/path.json"
import renameviewMod from '../components/renameView.vue'
import WordCloud from '../components/widgets/wordCloud.vue'
import TreeMap from '../components/widgets/treeMap.vue'
import AgingTrend from '../components/widgets/agingTrend.vue'
import DailyTrend from '../components/widgets/dailyTrend.vue'
import WorldMap from '../components/widgets/worldMap.vue'
import HourlyTrend from '../components/widgets/hourlyTrend.vue'
import VarianceHeat from '../components/widgets/varianceHeat.vue'
import BubbleTrend from '../components/widgets/bubbleTrend.vue'
import IncomingTrend from '../components/widgets/incomingTrend.vue'
import MTTRView from '../components/widgets/mttr.vue'
import ReopenTrend from '../components/widgets/reopenTrend.vue'
import ReassignTrend from '../components/widgets/reassignTrend.vue'
import SLATrend from '../components/widgets/slaTrend.vue'
import TierView from '../components/widgets/tierTrend.vue'
import BumpView from '../components/widgets/bumpview.vue'
import Waterfall from '../components/widgets/waterFall.vue'
import SankeyView from '../components/widgets/sankey.vue'
import CustTreeMap from '../components/widgets/custTreeMap.vue'
import PivotChart from '../components/widgets/pivotChart.vue'
import KeyDeep from '../components/keyDeep.vue'
import dataTempT from '../data/timezones.json'
import analzerLoaderComp from '../components/smallcomp/analzerloader.vue'
import pageLoaderComp from '../components/smallcomp/pageloader.vue'
import DeleteModal from '../components/deleteModal.vue'
import widgetLoadingComp from '../components/smallcomp/widgetloader.vue'
import ExplainModal from '../components/explainModal.vue'
import SparkLine from "../components/smallcomp/SparkLine.vue";
import screenShotMix from "./../mixin/screenShotMix";
import 'vue-multiselect/dist/vue-multiselect.min.css'
import * as echarts from 'echarts';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
  once: true,
});
const cols = [{
  headerName: "Assessment Name",
  field: "name",
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    buttons: ['reset', 'apply']
  }
},
{
  headerName: "Created By",
  field: "cret_by",
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    buttons: ['reset', 'apply']
  }
},
{
  headerName: "Delete View",
  field: "cret_by",
  cellRenderer: params => {
    // put the value in bold
    if (params.data.issel || params.data.id < 2 || !params.data.isOwner) {
      return ''
    } else {
      return '<span><svg class="svg-inline--fa fa-trash-alt myfaBtn listIcon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"></path></svg></span>';
    }
  }
},
{
  headerName: "Toogle View Bookmark",
  field: "cret_by",
  cellRenderer: params => {
    // put the value in bold
    if (params.data.issel) {
      return ''
    } else if (!params.data.isBookmarked) {
      return '<span><svg class="svg-inline--fa fa-bookmark myfaBtn listIcon" aria-hidden="true" focusable="false" data-prefix="far" data-icon="bookmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"></path></svg></span>';
    } else {
      return '<span><svg class="svg-inline--fa fa-bookmark myfaBtn listIcon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bookmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"></path></svg></span>';
    }
  }
}
]
export default {
  inheritAttrs: false,
  name: 'visualizationPage',
  mixins: [screenShotMix],
  components: {
    renameviewMod,
    Datepicker,
    WordCloud,
    AgingTrend,
    TreeMap,
    DailyTrend,
    WorldMap,
    HourlyTrend,
    VarianceHeat,
    BubbleTrend,
    IncomingTrend,
    MTTRView,
    ReopenTrend,
    ReassignTrend,
    SLATrend,
    TierView,
    BumpView,
    Waterfall,
    SankeyView,
    CustTreeMap,
    PivotChart,
    KeyDeep,
    AgGridVue,
    analzerLoaderComp,
    widgetLoadingComp,
    DeleteModal,
    pageLoaderComp,
    draggable,
    ExplainModal,
    SparkLine,
  },
  data() {
    return {
      selected: "",
      AsgName: "",
      ViewName: "",
      modules: [ClientSideRowModelModule],
      asgcolsDefs: cols,
      loadico: ['fas', 'bookmark'],
      loadicoI: ['far', 'bookmark'],
      Is_bookmark: false,
      widgetHolder: widgetHolder,
      isadvSetsDrill: true,
      isadvSets: false,
      isShowSaved: false,
      showViewList: false,
      isInsightloaded: true,
      isAnalysisloaded: true,
      showAsmtSettingsIn: false,
      loneshow: false,
      isInsOn: false,
      showWrapper: false,
      selection: 7,
      tabsel: 7,
      uname: "",
      inquiIssop: "",
      inquiAssgnop: "",
      isReadOnlyView: false,
      isClone: false,
      criticalVal: [],
      noncriticalVal: [],
      criticalOpts: [],
      tabno: 'tab-1',
      isTab1: false,
      asgLis: null,
      iskeyMTTR: false,
      iskeyHM: false,
      iskeyInc: false,
      p1_perc: "",
      we_mode: "",
      isImport: false,
      isDataPattern: null,
      p1_Tic_count: "",
      keyInsCard: {},
      tempLoaderShow: false,
      filterPopShow: false,
      getCard: {},
      showPriorityPatch: false,
      ticketcount: "",
      FilterTic_Count: 0,
      showPcards: false,
      showPCard: false,
      showReopenCard: false,
      isKeyReopen: false,
      reopen_perc: "",
      Reopen_Tic_count: "",
      Reassign_perc: "",
      reassign_range_count: "",
      Resp_perc: "",
      Resp_adher_count: "",
      Resol_perc: "",
      Resol_adher_count: "",
      inquiSolop: "",
      showReassgCard: false,
      showRespCard: false,
      showResolCard: false,
      showFilterIcon: false,
      isRemoveBlank: true,
      chartNo: 101,
      cond: 0,
      showEdited: false,
      KITic_Count: 0,
      portlevels: [],
      savePopShow: false,
      startdt: new Date(),
      enddt: new Date(),
      AnalysisOp: null,
      ins_priorLv2op: "",
      priorLvs_drop1: [],
      getgudLis: [],
      getnongudLis: [],
      savedSettings: [],
      allViews: [],
      loadedView: "",
      wgtTypeload: null,
      initialStart: "",
      initialEnd: "",
      colsview: true,
      AnalysisOns: [],
      AnalysisOnBkp: [],
      getdropsdata: [],
      prior_list: [],
      fieldArr: [],
      l2dispname: "",
      myTabWidthH: "",
      enabledWidget: [],
      widgetInfo: [],
      isMTTRPresent: null,
      showDeleteModal: false,
      splitOps: [],
      isExist: false,
      isportError: true,
      wholePortdata: [],
      catop: null,
      splitop: null,
      keydrive: [{
        Ins_hdr: "",
        key_ins: []
      }],
      kins_temp: "",
      getWc: {},
      getBubble: {},
      getBump: {},
      getWF: {},
      changePassdata: {},
      passpinInfo: {},
      get_prior: "All",
      changedwgtTemp: "",
      custview: "",
      isKeyDeep: false,
      send_ins: {},
      isDeleteSuccessful: false,
      timeZoneArr: dataTempT,
      timeZone: "",
      asgLisApi: null,
      isOwner: false,
      getscorelbls: [],
      slider: {
        minValue: 10,
        maxValue: 90,
        minLimit: 10,
        maxLimit: 90,
        resetMin: 0,
        resetMax: 0,
        options: {
          floor: 0,
          ceil: 100,
          step: 1
        }
      },
      iskeysla: false,
      getcriticPrior: {},
      tabName: 'Portfolio View',
      portfolioMTTROverride: false,
      mttadata: [],
      mttrdata: [],
      mttreassdata: [],
      mttreopendata: [],
      myColorArray: [],
      myBorderArray: [],
      isslaadherence: false,
      settingLoader: false,
      getcolumnpriorToChild: {},
      fliterPopup: undefined,
      SB_Name: null,
      showfooterPDF: false,
      loaderFixArr: [],
      clickInsightLoad: false,
      keyInsightLoad: [],
      isWrShare: false,
      enabled: true,
      priorityOrder: [],
      choosRange: true,
      daysRange: null,
      enableDayRange: false,
      isLive: false,
      isViewChange: null,
      storeTabselected:null
    }
  },
  methods: {
    changeViewName() {
      this.isExist = false;
    },
    toggleDark() {
      var getTheme = this.$sessionData.get('uinofo_sess')
      var basetheme = getTheme.base_Color
      if (basetheme == "dark") {
        document.body.classList.add("darkTheme")
        document.body.classList.remove("lightTheme")
      } else {
        document.body.classList.add("lightTheme")
        document.body.classList.remove("darkTheme")
      }
    },
    export2PDF() {
      this.clickInsightLoad = true;
      if (this.keyInsightLoad.filter(data => data.show == true).length === 0) {
        this.showfooterPDF = true;
        this.myExpandInsAll()
        this.$notify({
          type: "success",
          text: "Exporting Key Insights as PDF..",
          duration: 10000
        })
        var element = document.getElementById('dcontent');
        if(element == null) return;
        if (document.body.classList.contains('darkTheme')) {
          document.body.classList.remove("darkTheme")
          document.body.classList.add("lightTheme")
        }
        if (this.loadedView == "") {
          this.SB_Name = "Untitled"
        } else {
          this.SB_Name = this.loadedView
        }
        var opt = {
          margin: 0.25,
          filename: 'OPSights_' + this.SB_Name + '_Insights.pdf',
          image: {
            type: 'jpeg',
            quality: 1.0
          },
          html2canvas: {
            scale: 2,
            letterRendering: true
          },
          pagebreak: {
            mode: ['avoid-all', 'legacy']
          },
          jsPDF: {
            unit: 'in',
            format: 'a2',
            orientation: 'portrait',
            fontSize: 4
          }
        };
        html2pdf().from(element).set(opt).save();
        setTimeout(() => {
          this.myCollapseInsAll();
          this.toggleDark();
          this.showfooterPDF = false;
          this.clickInsightLoad = false;
          this.$notify({
            type: "success",
            text: "PDF has downloaded.",
          })
        }, 7000);
      } else {
        this.clickInsightLoad = false;
        this.$notify({
          type: "error",
          text: "OPSight loading the insight. Please wait.",
        })
      }
    },
    explainModel(currpass) {
      let sendobj = {
        "currpass": currpass.replaceAll('%20', ' '),
        "Cond": 0,
        "selid": selectedId,
      }
      this.$refs.explainPra.showExpModal(sendobj)
    },
    resetMinMax(set, resetval) {
      if (set == 0) {
        this.slider.minValue = resetval;
      } else {
        this.slider.maxValue = resetval;
      }
    },
    tryReload(condper) {
      let cond = 0;
      this.getKey_dim(cond, condper)
    },
    sendKeyInsErr(Inshdr) {
      let sendermail = this.$sessionData.get('uinofo_sess').mailto;
      let asgid = this.$sessionData.get('asgID404')
      let analysefld = this.filterLevelConv(false)
      this.keyInsRepMail(asgid, Inshdr, insightInfo.startdate, insightInfo.enddate, this.AnalysisOp.dbname,
        analysefld, sendermail)
    },
    keyInsRepMail(asgid, InsHdrasgid, startdate, enddate, Analyzefield, filtervals, sendermail) {
      var subject = "Opsight Azure GA Support : Reporting Key Observation Error Issue";
      var yourMessage = "Hi Support team," + "\n\nBelow are the details that are captured for this Insight error:\n";
      yourMessage += "Assessment ID : " + asgid + "\n";
      yourMessage += "Key Insight For: " + InsHdrasgid + "\n";
      yourMessage += "Date Period : " + startdate + '-' + enddate + "\n";
      if (Analyzefield != undefined) {
        yourMessage += "Analysis Based on : " + Analyzefield + "\n";
      }
      if (filtervals.length != 0) {
        yourMessage += "Filter Selected: " + "No Filter Values selected" + "\n";
      } else {
        yourMessage += "Filter Selected: " + filtervals + "\n";
      }
      document.location.href = sendermail +
        encodeURIComponent(subject) +
        "&body=" + encodeURIComponent(yourMessage);
    },
    addToSlider() {
      let insArr = [];
      let name = "Portfolio View for " + this.catop.name + " and " + this.splitop.name;
      let screenShort = {
        id: 'portfolioSnapInner',
        name: 'portfolioSnapInner.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    spanInfo(text) {
      return `${text}`
    },
    onTickets(params, val) {
      let clickitem
      if (val == 1) {
        clickitem = {
          "currpass": params,
          "filterop": "Resolution",
          "splcond": "Resolution~All~0~1000000000000000000"
        }
      } else {
        clickitem = {
          "currpass": params,
          "filterop": "Response",
          "splcond": "Response~All~0~1000000000000000000"
        }
      }
      this.drillkeyItem(clickitem, 2)
    },
    saveInsSetts() {
      this.isSetupload = false;
      let sendsetts2 = {}
      if (this.isImport) {
        sendsetts2 = {
          "is_import": this.isImport,
          "we_mode": this.we_mode
        }
      } else {
        var insSetsdata = this.getscorelbls;
        insSetsdata = insSetsdata.map((item) => {
          let opt = item.opt;
          let value = item.value;
          for (let i = 0; i < opt.length; i++) {
            let obj = value.find(o => o.valname === opt[i].valname);
            if (obj == undefined) {
              opt[i].ticked = false;
            }
          }
          return item = {
            label: item.label,
            opt: opt
          }
        })
        if(this.setupinfo.type_inqui.is_import === undefined){
          this.isImport = false
        }else{
          this.isImport = this.setupinfo.type_inqui.is_import;
        }
        sendsetts2 = {
          "is_import": this.isImport,
          "we_mode": this.we_mode,
          "typesets": insSetsdata,
          "inqui_issue": this.inquiIssop,
          "inqui_sol": this.inquiSolop,
          "inqui_assignee": this.inquiAssgnop,
          "inquiSol_drops": this.sol_drops,
          "inquiIss_drops": this.iss_drops,
          "inquiAssgn_drops": this.assgn_drops,
          "isAsg_type": this.isHetro,
          "priorityOrder": this.priorityOrder.join('~')
        }
      }
      if (this.getcriticPrior != undefined & this.getcriticPrior.length != 0) {
        sendsetts2.criticLis = this.criticalVal
        sendsetts2.noncriticLis = this.noncriticalVal
      }
      this.axios.post(this.uriApiUrl + "UserSetting/save_settings?AsgID=" + this.asgId + "&Cond=" + 1, sendsetts2,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data != "Error" && response.data == "Success") {
            this.isUploadload = true;
            this.$notify({
              type: "success",
              text: 'Settings saved Successful'
            });
          } else if (response.data == "Error") {
            this.$notify({
              replaceMessage: true,
              delay: "never",
              startTop: 50,
              maxCount: 5,
              type: "error",
              text: 'Sorry! An error occurred while Saving the settings! Kindly save it after sometime'
            });
          }
          this.isSetupload = true;
        }, function (response) {
          this.$notify({
            replaceMessage: true,
            delay: "never",
            startTop: 50,
            maxCount: 5,
            type: "error",
            text: 'Sorry! Connection Issue Occured'
          });
          this.isSetupload = true;
        });
    },
    accBtn(id) {
      if (this.selected === id) {
        this.selected = ''
      } else {
        this.selected = id;
      }
    },
    myExpandIns(param) {
      for (let index = 0; index < param.length; index++) {
        const element = param[index];
        var target = document.getElementById('ins-' + element.id);
        if (target != null) {
          target.checked = true;
        }
      }
    },
    myCollapseIns(param) {
      for (let index = 0; index < param.length; index++) {
        const element = param[index];
        var target = document.getElementById('ins-' + element.id);
        if (target != null) {
          target.checked = false;
        }
      }
    },
    myExpandInsAll() {
      for (let index = 0; index < this.keydrive.length; index++) {
        const element = this.keydrive[index];
        for (let index = 0; index < element.key_ins.length; index++) {
          const element1 = element.key_ins[index];
          var target = document.getElementById('ins-' + element1.id);
          if (target != null) {
            target.checked = true;
          }
        }
      }
    },
    myCollapseInsAll() {
      for (let index = 0; index < this.keydrive.length; index++) {
        const element = this.keydrive[index];
        for (let index = 0; index < element.key_ins.length; index++) {
          const element1 = element.key_ins[index];
          var target = document.getElementById('ins-' + element1.id);
          if (target != null) {
            target.checked = false;
          }
        }
      }
    },
    getViewList(chkOpen) {
      this.isInsightloaded = false
      this.axios.get(this.uriApiUrl + "UserSetting/getviews?asg_id=" + this.asgId + "&Cond=0",{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data != "Error") {
            this.showViewList = chkOpen;
            this.asgLis = response.data;
            this.asgLisApi.setRowData(this.asgLis)
          }
          this.isInsightloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    visualOn(InsIn) {
      this.selection = InsIn.optset;
      this.Ins_hdr = InsIn.Ins_hdr;
      this.switchMtab();
      switch (InsIn.optset) {
        case 0:
          this.isKeyWC = true;
          break;
        case 1:
          if (this.Ins_hdr == "Monthly Ticket Trends") {
            this.iskeyInc = true;
          } else {
            this.iskeyHM = true;
          }
          break;
        case 2:
          if (this.Ins_hdr == "Acknowledgement SLA") {
            this.iskeysla = true;
          } else {
            this.iskeyMTTR = true;
          }
          break;
        case 3:
          if (this.Ins_hdr == "Resolution SLA") {
            this.iskeysla = true;
          } else {
            this.iskeyMTTR = true;
          }
          break;
        case 4:
          this.isKeyReopen = true;
          break;
        case 5:
          this.isKeyReassg = true;
          break;
        default:
          break;
      }
    },
    convert2ddhhmm(minutesValue, suffix) {
      if (suffix != "") {
        if (suffix.toUpperCase() == "H") {
          minutesValue = minutesValue * 60;
        } else if (suffix.toUpperCase() == "D") {
          minutesValue = minutesValue * 60 * 8;
        }
        var hours = Math.floor(minutesValue / 60);
        var minutes = Math.round((minutesValue % 60), 2);
        var days = 0;
        if (hours > 24) {
          days = Math.floor(hours / 24);
          hours = Math.floor(hours % 24);
        }
        var returnVal = '';
        if (days != 0) {
          returnVal += days + 'd ';
        }
        if (hours != 0) {
          returnVal += hours + 'h ';
        }
        if (minutes != 0) {
          returnVal += minutes + 'm ';
        }
      } else {
        returnVal = minutesValue;
      }
      if (returnVal == 0) {
        returnVal = '-'
      }
      return returnVal;
    },
    downloadPort() {
      let imgname = "portfolio.png"
      let widgetID = "portfolioSnapInner"
      var geticondiv = document.querySelectorAll(
        '#portfolioSnapInner .insideL,#portfolioSnapInner .insideR, .hidePic')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv = document.querySelectorAll(
            '#portfolioSnapInner .insideL,#portfolioSnapInner .insideR, .hidePic')
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downKeyIns(InsIn) {
      this.Ins_hdr = InsIn.Ins_hdr;
      var newArr = [],
        insArr = [];
      for (var d = 0; d < this.keydrive.length; d++) {
        if (this.keydrive[d].Ins_hdr == this.Ins_hdr) {
          insArr = this.keydrive[d].key_ins;
          break;
        }
      }
      for (var i = 0; i < insArr.length; i++) {
        let elem1 = insArr[i];
        newArr.push(elem1.name);
        for (var j = 0; j < elem1.values.length; j++) {
          let elem2 = elem1.values[j]
          elem2 = elem2.replace(/\|/g, '').replace(/~/g, '');
          newArr.push(elem2);
        }
        newArr.push("");
      }
      var txtIns = newArr.join("\r\n");
      var fileName = InsIn.Ins_hdr + '_Key_Insights.txt';
      var fileToSave = new Blob([txtIns], {
        type: 'application/json',
        name: fileName
      });
      FileSaver.saveAs(fileToSave, fileName);
    },
    onCellClicked(params) {
      if (params.colDef.headerName == "Delete View") {
        if (params.rowIndex != 0 && !params.data.issel) {
          this.deleteView(params.data.id, params.data.name, true);
          if (this.isDeleteSuccessful) {
            if (params.rowIndex > -1) {
              this.asgLis.splice(params.rowIndex, 1);
            }
            this.asgLisApi.setRowData(this.asgLis)
          }
        }
      } else if (params.colDef.headerName == "Toogle View Bookmark") {
        this.bookmarkview(params, params.data.id, !params.data.isBookmarked, true);
      }
    },
    onPriorAsg(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis)
    },
    portClick(val12, typeClick) {
      let isOthers = false;
      let filterOps
      if (typeClick == 0) {
        filterOps = this.catop.dbname
        if (val12 == "(OTHERS)") {
          isOthers = true;
        }
      } else {
        let tempValChk = val12.split('~');
        filterOps = this.catop.dbname + '~' + this.splitop.dbname
        if (tempValChk[0] == "(OTHERS)" || tempValChk[1] == "(OTHERS)") {
          isOthers = true;
        }
      }
      if (isOthers) {
        this.$notify({
          type: "warning",
          text: "Sorry! We currently don't support doubleclick for 'Others' value"
        })
      } else {
        this.drillkeyItem({
          currpass: val12,
          filterop: filterOps
        }, 1);
      }
    },
    saveViewFn(val) {
      if (this.ViewName == undefined) {
        this.$notify({
          type: "warning",
          text: 'Please Provide the View Name'
        })
      } else {
        if (/^[A-Za-z0-9\s_-]+$/.test(this.ViewName) == false) {
          this.$notify({
            type: "warning",
            text: "View Name Should not contain special characters"
          })
        } else if (this.ViewName == 'WorkSpace') {
          this.$notify({
            type: "warning",
            text: "Please select the other view name"
          })
        } else {
          var UserData = {
            'view_name': this.ViewName,
            'overRide': val
          };
          viewNameV = this.ViewName
          this.axios.post(this.uriApiUrl + "UserSetting/save_view?asg_id=" + this.asgId, UserData,{
      headers: {
            'Content-Type': 'application/json'
          }})
            .then((response) => {
              let resData = response.data;
              if (resData.includes("denied")) {
                var pinview = response.split(',');
                this.status = pinview[0];
                this.uname = pinview[1];
                this.$notify({
                  type: "error",
                  text: 'Read-only View! Do you want to clone?'
                })
                this.isClone = true;
                this.SaveTickFlag = false;
              } else if (resData != "Exists" && resData != "Error" && resData !="Invalidinput") {
                this.isExist = false;
                this.override = val;
                if (this.override != 1) {
                  selectedId = ""
                }
                this.savePopShow = !this.savePopShow
                this.getAnalyse(2);
              } else if (resData == "Exists") {
                this.isExist = true;
                this.$notify({
                  type: "error",
                  text: 'View Already Exists! Do you want to override?'
                })
                this.SaveTickFlag = false;
              }else if (resData == "Invalidinput") {
                this.$notify({
                  type: "warning",
                  text: "View Name Should not contain special characters",
                })
              }
              else {
                this.$notify({
                  type: "error",
                  text: 'Unable to save the view! Please retry and if you still face issues contact the support team'
                })
                this.SaveTickFlag = false;
              }
            }).catch((error) => {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong. Please retry and if you still face issues contact the support team'
              })
            })
        }
      }
    },
    saveSetting() {
      this.savePopShow = true
      this.ViewName = insightInfo.last_viewed_id[1]
    },
    customLabel({
      value,
      abbr
    }) {
      return `${value}(${abbr})`
    },
    customLabelFilter({ val, count }) {
      if (count == undefined && val === undefined) {
        return
      } else if (count == undefined) {
        return `${val}`
      } else {
        return `${val}(# Tickets: ${count})`
      }
    },
    customLabelField({
      name,
      fillVal,
      uniqueVal
    }) {
      if (fillVal == undefined) {
        return `${name}`
      }
      return `${name}(Filled: ${fillVal}%, Uniq. Val.: ${uniqueVal})`
    },
    setDirty() {
      this.showWrapper = true
      this.showEdited = true
      viewNameV = ''
      for (var i = 0; i < this.savedSettings.length; i++) {
        this.savedSettings[i].issel = false
      }
    },
    timeZoneArrConv(isBackEndToFrontEnd) {
      if (isBackEndToFrontEnd) {
        let tempVar = this.timeZone.split("~")[0];
        let fffffff = this.timeZoneArr.filter(function (itm) {
          return itm.value == tempVar;
        });
        this.timeZone = fffffff[0];
      } else {
        let fffffff = this.timeZone.value + "~" + this.timeZone.offset;
        this.timeZone = fffffff;
      }
    },
    filterLevelConv(isBackEndToFrontEnd) {
      let returnVal = [];
      let filterVal = [];
      if (isBackEndToFrontEnd) {
        for (let index = 0; index < this.portlevels.length; index++) {
          filterVal = []
          const element = this.portlevels[index];
          element.filter_key = this.getdropsdata.filter(function (itm) {
            return itm.dbname == element.filter_key;
          })[0];
          element.filterDisp = element.filter_key.name
          for (let index = 0; index < element.filter_vals.length; index++) {
            const element1 = element.filter_vals[index];
            filterVal.push({
              val: element1
            })
          }
          element.filter_vals = filterVal;
          returnVal.push(element)
        }
      } else {
        for (let index = 0; index < this.portlevels.length; index++) {
          filterVal = []
          const element = this.portlevels[index];
          if (element.filter_key != null) {
            element.filter_key = element.filter_key.dbname;
            for (let index = 0; index < element.filter_vals.length; index++) {
              const element1 = element.filter_vals[index];
              filterVal.push(element1.val)
            }
            element.filter_vals = filterVal;
            returnVal.push(element)
          }
        }
      }
      return (returnVal);
    },
    showQcols(fname, fQuality) {
      this.colsview = false;
      setTimeout(function () {
        this.getcolQname = fname;
        this.getcolQval = fQuality;
        this.colsQTemp = this.comp_path[0].comp_path;
      }, 5);
    },
    delAssessment() {
      let hdr = "Delete Assessment"
      this.$refs.deltModal.showDeltModal(hdr)
    },
    bookmarkview(params, viewID, isBookmarked, isfromList) {
      let resp;
      this.axios.get(this.uriApiUrl + 'UserSetting/bookmarkview?rowid=' + viewID + '&bookmark=' + isBookmarked +
        '&asg_id=' + this.asgId,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (isBookmarked == true) {
            resp = "Pinned"
          } else {
            resp = "Unpinned"
          }
          if (response.data != "Error") {
            this.$notify({
              type: "success",
              text: 'View has been ' + resp + ' successfully.'
            });
            this.savedSettings = response.data;
            if (isfromList) {
              this.asgLis[params.rowIndex].isBookmarked = !this.asgLis[params.rowIndex].isBookmarked
              this.asgLisApi.setRowData(this.asgLis)
            }
          } else {
            this.$notify({
              type: "error",
              text: 'Failed to ' + resp + ' the View.'
            });
          }
          this.isInsightloaded = true
          this.isAnalysisloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.isAnalysisloaded = true
          this.$notify({
            type: "error",
            text: 'Not able to add/Remove BookMark!Try After Some Time'
          })
        })
    },
    bookMarkClick() {
      this.axios.get(this.uriApiUrl + 'UserSetting/save_bookmarks?asg_id=' + this.asgId,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data == 'Yes') {
              this.$store.state.Is_bookmark = 'Yes'
              this.Is_bookmark = 'Yes'
              this.$notify({
                type: "success",
                text: "Assesssment Bookmarked!"
              })
            } else if (response.data == 'No') {
              this.$store.state.Is_bookmark = 'No'
              this.Is_bookmark = 'No'
              this.$notify({
                type: "error",
                text: "Assesssment BookMark Removed!"
              })
            }
          }
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: "Not able to add/Remove BookMark!Try After Some Time"
          })
        })
    },
    chartVisbility(variance) {
      this.chartNo = 2
      this.tempLoaderShow = true
      this.selection = variance
      this.tabsel = variance
      this.$store.commit("setWidgetCond", this.selection)
      this.showFilterIcon = false
      this.showPriorityPatch = false
      this.showRespCard = false
      this.showResolCard = false
      this.showReopenCard = false
      this.showReassgCard = false
      this.showPcards = true
      this.enabledWidget = []
      this.isInsightloaded = false
      this.isAnalysisloaded = false
      changeCC = "reset"
      changeCust = "reset"
      this.isTab1 = false;
      switch (variance) {
        case -1:
          this.isTab1 = true;
          this.getKeyInsights(2);
          break;
        case 0:
          this.showRespCard = true
          this.showResolCard = true
          this.showReopenCard = true
          this.showReassgCard = true
          this.FilterTic_Count = this.getCard.ticketcount
          this.wcinfo = this.widgetInfo.wc_overall
          this.treeinfo = this.widgetInfo.Treeview_overall
          this.mttrinfo = this.widgetInfo.mttr_overall
          this.Resp_perc = this.getCard.overall_Respadher
          this.Resol_perc = this.getCard.overall_Resoladher
          this.Reopen_Tic_count = this.getCard.Reopen_Tic_count
          this.reassign_range_count = this.getCard.Reassign_Tic_count
          this.Resp_adher_count = this.getCard.Overall_Resp_adher_count
          this.Resol_adher_count = this.getCard.Overall_Resol_adher_count
          this.p1_perc = this.getCard.p1_type_filt_perc
          this.p1_Tic_count = this.getCard.p1_type_filt_count
          this.reopen_perc = this.getCard.overall_reopenperc
          this.Reassign_perc = this.getCard.overall_Reassignperc
          this.tabName = 'Overall'
          break
        case 1:
          this.wcinfo = this.widgetInfo.wc_incoming
          this.treeinfo = this.widgetInfo.Treeview_incoming
          this.bubbleinfo = this.widgetInfo.bubble_incoming
          this.tabName = 'Incoming'
          break
        case 2:
          this.showRespCard = true
          this.showFilterIcon = true
          this.showPriorityPatch = true
          if (this.get_prior == "All") {
            geticondiv = document.querySelectorAll('.grpBtn3')
            geticondiv.forEach(box => {
              box.classList.remove("themeclr")
            });
            geticondiv = document.querySelectorAll('.grpBtn3:nth-child(1)')
            geticondiv[0].classList.add("themeclr")
          }
          this.FilterTic_Count = this.getCard.Resp_Tab_Tic_count
          this.Resp_perc = this.getCard.Resptabadher
          this.Resp_adher_count = this.getCard.Resp_adher_count
          this.p1_perc = this.getCard.resp_range_p1perc
          this.p1_Tic_count = this.getCard.resp_range_p1count
          this.wcinfo = this.widgetInfo.wc_resp
          this.treeinfo = this.widgetInfo.Treeview_resp
          this.mttrinfo = this.widgetInfo.mttr_resp
          this.bubbleinfo = this.widgetInfo.bubble_response
          this.slainfo = this.widgetInfo.resp_sla
          if (insightInfo.rangein.resp_range.length != 0) {
            this.slider.minValue = insightInfo.rangein.resp_range[0]
            this.slider.maxValue = insightInfo.rangein.resp_range[1]
            this.slider.resetMin = insightInfo.rangein.resp_range[2]
            this.slider.resetMax = insightInfo.rangein.resp_range[3]
            this.slider.minLimit = insightInfo.rangein.resp_range[2]
            this.slider.maxLimit = insightInfo.rangein.resp_range[3]
            this.slider.options.ceil = insightInfo.rangein.resp_range[3]
          } else {
            this.showFilterIcon = false
          }
          this.passpinInfo = {
            "selid": selectedId,
            "edited": this.showEdited,
            "get_prior": this.get_prior,
            "viewName": this.loadedView
          }
          this.tabName = 'Ack. Time'
          break
        case 3:
          this.showResolCard = true
          this.showFilterIcon = true
          this.showPriorityPatch = true
          if (this.get_prior == "All") {
            geticondiv = document.querySelectorAll('.grpBtn3')
            geticondiv.forEach(box => {
              box.classList.remove("themeclr")
            });
            geticondiv = document.querySelectorAll('.grpBtn3:nth-child(1)')
            geticondiv[0].classList.add("themeclr")
          }
          this.FilterTic_Count = this.getCard.Reso_Tab_Tic_count
          this.Resol_perc = this.getCard.Resotabladher
          this.Resol_adher_count = this.getCard.Resol_adher_count
          this.p1_perc = this.getCard.resol_range_p1perc
          this.p1_Tic_count = this.getCard.resol_range_p1count
          this.wcinfo = this.widgetInfo.wc_resol
          this.treeinfo = this.widgetInfo.Treeview_resol
          this.mttrinfo = this.widgetInfo.mttr_resol
          this.bubbleinfo = this.widgetInfo.bubble_resol
          this.slainfo = this.widgetInfo.resol_sla
          if (insightInfo.rangein.resol_range.length != 0) {
            this.slider.minValue = insightInfo.rangein.resol_range[0]
            this.slider.maxValue = insightInfo.rangein.resol_range[1]
            this.slider.resetMin = insightInfo.rangein.resol_range[2]
            this.slider.resetMax = insightInfo.rangein.resol_range[3]
            this.slider.minLimit = insightInfo.rangein.resol_range[2]
            this.slider.maxLimit = insightInfo.rangein.resol_range[3]
            this.slider.options.ceil = insightInfo.rangein.resol_range[3]
          } else {
            this.showFilterIcon = false
          }
          this.passpinInfo = {
            "selid": selectedId,
            "edited": this.showEdited,
            "get_prior": this.get_prior,
            "viewName": this.loadedView
          }
          this.tabName = 'Resln. Time'
          break
        case 4:
          this.showFilterIcon = true
          this.FilterTic_Count = this.getCard.Reopen_Tab_Tic_Count
          this.reopen_perc = this.getCard.reopen_range_perc
          this.p1_perc = this.getCard.reopen_range_p1perc
          this.p1_Tic_count = this.getCard.reopen_range_p1count
          this.wcinfo = this.widgetInfo.wc_reopen
          this.treeinfo = this.widgetInfo.Treeview_reopen
          this.mttrinfo = this.widgetInfo.mttr_reopen
          if (insightInfo.rangein.reopen_range.length != 0) {
            this.slider.minValue = insightInfo.rangein.reopen_range[0]
            this.slider.maxValue = insightInfo.rangein.reopen_range[1]
            this.slider.resetMin = insightInfo.rangein.reopen_range[2]
            this.slider.resetMax = insightInfo.rangein.reopen_range[3]
            this.slider.minLimit = insightInfo.rangein.reopen_range[2]
            this.slider.maxLimit = insightInfo.rangein.reopen_range[3]
            this.slider.options.ceil = insightInfo.rangein.reopen_range[3]
          } else {
            this.showFilterIcon = false
          }
          this.passpinInfo = {
            "selid": selectedId,
            "edited": this.showEdited,
            "get_prior": this.get_prior,
            "viewName": this.loadedView
          }
          this.tabName = 'Reopen'
          break
        case 5:
          this.showFilterIcon = true;
          this.FilterTic_Count = this.getCard.Reassign_Tab_Tic_count
          this.Reassign_perc = this.getCard.reassign_range_perc
          this.p1_perc = this.getCard.reassign_range_p1perc
          this.p1_Tic_count = this.getCard.reassign_range_p1count
          this.wcinfo = this.widgetInfo.wc_reasg
          this.treeinfo = this.widgetInfo.Treeview_reasg
          this.mttrinfo = this.widgetInfo.mttr_reasg
          if (insightInfo.rangein.reassign_range.length != 0) {
            this.slider.minValue = insightInfo.rangein.reassign_range[0]
            this.slider.maxValue = insightInfo.rangein.reassign_range[1]
            this.slider.resetMin = insightInfo.rangein.reassign_range[2]
            this.slider.resetMax = insightInfo.rangein.reassign_range[3]
            this.slider.minLimit = insightInfo.rangein.reassign_range[2]
            this.slider.maxLimit = insightInfo.rangein.reassign_range[3]
            this.slider.options.ceil = insightInfo.rangein.reassign_range[3]
          } else {
            this.showFilterIcon = false
          }
          this.passpinInfo = {
            "selid": selectedId,
            "edited": this.showEdited,
            "get_prior": this.get_prior,
            "viewName": this.loadedView
          }
          this.tabName = 'Reassign'
          break
        case 6:
          this.FilterTic_Count = this.getCard.ticketcount
          this.p1_perc = this.getCard.p1_type_filt_perc
          this.drillcount = 1
          this.tabName = 'Converged'
          break
        case 7:
          this.showPCard = true;
          this.showHeaderCard = true;
          this.showRespCard = true;
          this.showResolCard = true;
          this.showReopenCard = true;
          this.showReassgCard = true;
          this.chartNo = 1;
          this.FilterTic_Count = this.getCard.ticketcount;
          this.Resp_perc = this.getCard.overall_Respadher;
          this.Resol_perc = this.getCard.overall_Resoladher;
          this.Reopen_Tic_count = this.getCard.Reopen_Tic_count;
          this.reassign_range_count = this.getCard.Reassign_Tic_count;
          this.Resp_adher_count = this.getCard.Overall_Resp_adher_count;
          this.Resol_adher_count = this.getCard.Overall_Resol_adher_count;
          this.p1_perc = this.getCard.p1_type_filt_perc;
          this.p1_Tic_count = this.getCard.p1_type_filt_count;
          this.reopen_perc = this.getCard.overall_reopenperc;
          this.Reassign_perc = this.getCard.overall_Reassignperc;
          this.getcategorydrop();
          this.tabName = 'Portfolio View'
          break
        case 8:
          this.bumpChartShow = true;
          this.chartNo = 3
          this.showPriorityPatch = false;
          setTimeout(() => {
            this.drawChangeChart(1);
          }, 100);
          break;
        case 9:
          this.chartNo = 4
          this.showPriorityPatch = false;
          setTimeout(() => {
            this.drawFancyChart(1)
          }, 100);
          this.showPriorityPatch = false;
          break;
        default:
          break;
      }
      this.isInsightloaded = true
      this.isAnalysisloaded = true
      if (variance >= 0 && variance < 7) {
        this.enabledWidget = enabledWidgetsLst[this.selection].wgtload
      }
    },
    closeKDeep() {
      this.isKeyDeep = false;
      this.$refs.keyDeepModal.closeQModal();
    },
    drillkeyItem(event, kval) {
      this.isKeyDeep = true
      let kpos
      let inspos
      let whereFrom
      let optVal
      let splcondVal = ""
      if (event.splcond == undefined) {
        splcondVal = ""
      } else {
        splcondVal = event.splcond
      }
      if (kval == 0) {
        let getval = event
        kpos = getval.kpos
        inspos = getval.inspos
        whereFrom = getval.whereFrom
        optVal = getval.optVal
      } else if (kval == 1) {
        kpos = 0
        whereFrom = 1
      } else {
        kpos = 0
        whereFrom = 1
        splcondVal = event.splcond
      }
      this.send_ins = {
        sendins_Dcol: "",
        selectedWCCol: "",
        whereFrom: "",
        splcond: splcondVal,
        sendins: "",
        kDrillcond: 0
      }
      var splitDkins
      if (whereFrom == 0) {
        splitDkins = event.currpass
        if (kpos == 0) {
          var DKlvl = this.keydrive[kpos].key_ins[inspos].values[optVal]
          this.send_ins.sendins_Dcol = DKlvl.split('|')[1].split('~')[0]
        }
      } else if (whereFrom == 1) {
        splitDkins = event.currpass
        this.send_ins.sendins_Dcol = splitDkins
        this.send_ins.selectedWCCol = event.filterop
        if (event.filt_val) {
          this.send_ins.filt_val = event.filt_val
        }
        switch (this.selection) {
          case 2:
            this.send_ins.splcond = "Response" + "~" + this.get_prior + "~" + this.slider.minValue + "~" + this.slider
              .maxValue
            break
          case 3:
            this.send_ins.splcond = "Resolution" + "~" + this.get_prior + "~" + this.slider.minValue + "~" + this
              .slider.maxValue
            break
          case 4:
            this.send_ins.splcond = "Reopen" + "~" + this.slider.minValue + "~" + this.slider.maxValue
            break
          case 5:
            this.send_ins.splcond = "Reassign" + "~" + this.slider.minValue + "~" + this.slider.maxValue
            break
          default:
            break
        }
      }
      if (splitDkins != undefined) {
        if (kpos == 1) {
          let tktMon = "month^"
          splitDkins = tktMon + splitDkins
        }
        this.send_ins.sendins = splitDkins
      }
      setTimeout(() => {
        this.$refs.keyDeepModal.showQModal()
      }, 20)
    },
    getKDrill(deepdata) {
      this.drillkeyItem(deepdata, 1)
    },
    drawsparkChrts(prefix, data, hasAdherence) {
      var sparklineC
      if (data.length) {
        var tooltipArr = data[0].Mttr_Month;
        var tooptipConv = this.convert2ddhhmm
        try {
          if (hasAdherence) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              let domEle = document.getElementById(prefix + "A" + index);
              sparklineC = new Sparkline(domEle, {
                lineColor: "#1e7895",
                minValue: 0,
                endColor: "#777",
                maxColor: "#11a8ab",
                minColor: "red",
                fillLighten: 0.75,
                tooltip: function (value, index, collection) {
                  return tooltipArr[index] + ': ' + value + "%";
                }
              });
              sparklineC.draw(element.spkLine_sla);
            }
          }
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            sparklineC = new Sparkline(document.getElementById(prefix + "V" + index), {
              lineColor: "#1e7895",
              minValue: 0,
              endColor: "#777",
              maxColor: "red",
              minColor: "#11a8ab",
              fillLighten: 0.75,
              tooltip: function (value, index, collection) {
                return tooltipArr[index] + ': ' + tooptipConv(value, 'M');
              }
            });
            sparklineC.draw(element.spkLine_mttr);
          }
        } catch (error) {
          // console.log(error)
        }
      }
    },
    getKey_dim(cond, condper) {
      this.isLoadKeyDim = true
      let obsindex;
      let foundIndex
      if (this.keyInsightLoad.length < 9) {
        this.keyInsightLoad.push({ "show": true, "where": condper })
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getkeyinsights?asg_id=' + this.asgId + "&Cond=" + cond +
        "&dimcond=" + condper, {
        "selid": selectedId,
        "edited": this.showEdited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data != "Error" && response.data != "Nodata") {
            var keydim_drive = response.data;
            obsindex = this.keydrive.findIndex(x => x.order === condper)
            this.keydrive[obsindex].key_ins = keydim_drive.key_ins;
            this.keydrive[obsindex].dimcond = condper;
            this.keydrive[obsindex].isLoadKeyDim = true;
            foundIndex = this.keyInsightLoad.findIndex(x => x.where == condper);
            this.keyInsightLoad[foundIndex].show = false;
            if (response.data.chrt_json != 'Nodata') {
              try {
                if (condper == 0) {
                  let wordwholedata = response.data.chrt_json
                  this.wordchart = JSON.parse(JSON.stringify(wordwholedata.slice(0)))
                  let tag_bar = new Array();
                  let tag_barl = new Array();
                  if (this.wordchart.length > 0) {
                    for (let i = 0; i < this.wordchart.length; ++i) {
                      let x = this.wordchart[i];
                      if ((x.value == "(Blanks)" && !this.isRemoveBlank)) {
                        let qqq = 1
                      } else {
                        tag_bar.push(x.count);
                        tag_barl.push(x.value)
                      }
                    }
                  }
                  setTimeout(() => {
                    let chartDomWC = document.getElementById('Chart0');
                    if(chartDomWC == null) return;
                    if (chartDomWC != null && chartDomWC != undefined) {
                      myChart0 = echarts.init(chartDomWC);
                      let option = {
                        tooltip: {
                          confine: true,
                          trigger: 'axis',
                        },
                        visualMap: {
                          type: 'continuous',
                          top: 0,
                          calculable: false,
                          text: ['High', 'Low'],
                          min: 0,
                          max: tag_bar[0],
                          inRange: {
                            color: this.$store.state.chartColor,
                          },
                          textStyle: {
                            color: '#777',
                            fontSize: 10
                          },
                        },
                        grid: {
                          top: 20,
                          bottom: 100
                        },
                        dataZoom: [{
                          disabled: false,
                          type: 'slider',
                          show: true,
                          start: 0,
                          end: 15,
                          handleSize: 8
                        },
                        {
                          disabled: false,
                          type: 'inside',
                          start: 0,
                          end: 15
                        },
                        {
                          disabled: false,
                          show: true,
                          yAxisIndex: 0,
                          filterMode: 'empty',
                          width: 30,
                          height: '80%',
                          showDataShadow: false,
                          left: '93%'
                        }
                        ],
                        xAxis: {
                          type: 'category',
                          show: true,
                          data: tag_barl,
                          silent: false,
                          splitLine: {
                            show: false
                          },
                          splitArea: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            rotate: 30,
                            width: 80,
                            overflow: 'truncate',
                            fontSize: 10,
                            color: "#777"
                          },
                        },
                        yAxis: {
                          type: 'value',
                          show: true,
                          splitArea: {
                            show: false
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        },
                        series: [{
                          itemStyle: {
                            borderRadius: 2,
                            opacity: 1,
                          },
                          animationDurationUpdate: 1000,
                          universalTransition: true,
                          type: 'bar',
                          data: tag_bar
                        }]
                      };
                      myChart0.setOption(option);
                      let myAnalysisOpDBName = this.AnalysisOp.dbname
                      let ddClick = this.drillkeyItem
                      myChart0.on('click', function (params) {
                        if (params.componentType === 'series') {
                          let clickitem = {
                            "currpass": params.name,
                            "filterop": myAnalysisOpDBName
                          }
                          ddClick(clickitem, 1)
                        }
                      });
                      this.keydrive[obsindex].isLoadKeyDim = true;
                    }
                  }, 100);
                } else if (condper == 1) {
                  let incomingdata = response.data.chrt_json
                  if (incomingdata === undefined) {
                    return
                  }
                  setTimeout(() => {
                    let chartDomIvC = document.getElementById('Chart1');
                    if(chartDomIvC == null) return;
                    if (chartDomIvC != null && chartDomIvC != undefined) {
                      myChart1 = echarts.init(chartDomIvC);
                      let optionIvC = {
                        tooltip: {
                          confine: true,
                          trigger: 'axis',
                        },
                        legend: {
                          type: 'scroll',
                          textStyle: {
                            color: "inherit"
                          }
                        },
                        grid: {
                          left: 0,
                          top: 50,
                          right: '3%',
                          bottom: 20,
                          containLabel: true
                        },
                        xAxis: [{
                          type: 'category',
                          data: incomingdata.Labels,
                          splitArea: {
                            show: false
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        }],
                        yAxis: [{
                          type: 'value',
                          name: '# Tickets',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitArea: {
                            show: false
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        },
                        {
                          type: 'value',
                          name: 'Resolution Rate',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitArea: {
                            show: false
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777",
                            formatter: function (value, index) {
                              return value + '%';
                            }
                          },
                        }
                        ],
                        series: [{
                          name: 'New',
                          type: 'bar',
                          data: incomingdata.Incbar,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(30,120,149,1.0)'
                            },
                            {
                              offset: 1,
                              color: 'rgba(30,120,149,0.4)'
                            }
                            ]),
                            borderColor: '#1e7895',
                            borderWidth: 1,
                            opacity: 1
                          }
                        },
                        {
                          name: 'Backlog',
                          type: 'bar',
                          data: incomingdata.backlogbar,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(233,55,55,1.0)'
                            },
                            {
                              offset: 1,
                              color: 'rgba(233,55,55,0.4)'
                            }
                            ]),
                            borderColor: '#bf444c',
                            borderWidth: 1,
                            opacity: 1
                          },
                        },
                        {
                          name: 'Resolved',
                          type: 'bar',
                          data: incomingdata.linetrend,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(0,99,0,1.0)'
                            },
                            {
                              offset: 1,
                              color: 'rgba(0,99,0,0.4)'
                            }
                            ]),
                            borderColor: '#006300',
                            borderWidth: 1,
                            opacity: 1
                          }
                        },
                        {
                          name: 'Resolution Rate',
                          type: 'line',
                          symbolSize: 8,
                          symbol: 'circle',
                          yAxisIndex: 1,
                          itemStyle: {
                            color: "#009000"
                          },
                          tooltip: {
                            confine: true,
                            valueFormatter: function (value) {
                              return value + ' %';
                            }
                          },
                          data: incomingdata.compperc
                        }
                        ]
                      };
                      myChart1.setOption(optionIvC, {
                        notMerge: true
                      });
                      let ddClick = this.drillkeyItem
                      myChart1.on('click', function (params) {
                        if (params.componentType === 'series' && params.data != undefined) {
                          let clickitem = {
                            "currpass": params.seriesName + "~" + params.name,
                            "filterop": "InVsCom"
                          }
                          ddClick(clickitem, 1)
                        }
                      });
                    }
                    this.keydrive[obsindex].isLoadKeyDim = true;
                  }, 100);
                } else if (condper == 2) {
                  let days, times;
                  let hourlywholedata = response.data.chrt_json
                  if (hourlywholedata.we_config == "wefs") {
                    days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
                  } else {
                    days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
                  }
                  times = ["12a", "1a", "2a", "3a", "4a", "5a", "6a", "7a", "8a", "9a", "10a",
                    "11a", "12p",
                    "1p", "2p", "3p", "4p", "5p", "6p", "7p", "8p", "9p", "10p", "11p"
                  ];
                  setTimeout(() => {
                    let chartDom = document.getElementById('Chart2');
                    if (chartDom != null && chartDom != undefined) {
                      myChart2 = echarts.init(chartDom);
                      let option;
                      let data = [];
                      let maxValue = 0;
                      for (let index = 0; index < hourlywholedata.length; index++) {
                        const element = hourlywholedata[index];
                        data.push([element.day - 1, element.hour - 1, element.value])
                        if (element.value > maxValue) {
                          maxValue = element.value;
                        }
                      }
                      option = {
                        tooltip: {
                          confine: true,
                          position: 'top',
                          formatter: (params) => {
                            return "#Tickets for " + days[params.value[1]] + " at " + times[params.value[
                              0]] +
                              " is " + params
                                .value[2];
                          },
                        },
                        grid: {
                          top: 10,
                          bottom: 40,
                          left: 100,
                          right: 10
                        },
                        xAxis: {
                          type: 'category',
                          triggerEvent: true,
                          data: times,
                          axisLabel: {
                            color: "#777",
                            fontSize: 8,
                            interval: 0,
                            rotate: 0
                          },
                          splitLine: {
                            show: true,
                            lineStyle: {
                              // Dark and light colors will be used in turns
                              color: '#777aaa77'
                            }
                          },
                          splitArea: {
                            show: false
                          },
                          axisLine: {
                            show: true, // Hide full Line
                          },
                        },
                        yAxis: {
                          type: 'category',
                          triggerEvent: true,
                          data: days,
                          axisLabel: {
                            color: "#777",
                            fontSize: 8,
                          },
                          splitLine: {
                            show: true,
                            lineStyle: {
                              // Dark and light colors will be used in turns
                              color: '#777aaa77'
                            }
                          },
                          splitArea: {
                            show: false
                          },
                          axisLine: {
                            show: false, // Hide full Line
                          },
                        },
                        visualMap: {
                          min: 0,
                          top: 0,
                          max: maxValue,
                          inRange: {
                            color: this.$store.state.chartColor,
                          },
                          text: ['High', 'Low'],
                          calculable: true,
                          orient: 'vertical',
                          left: 'left',
                          textStyle: {
                            color: '#777',
                            fontSize: 10
                          },
                        },
                        series: [{
                          name: '# Tickets',
                          type: 'effectScatter',
                          symbolSize: function (val) {
                            let sizeVal = val[2] / maxValue * 10
                            return sizeVal < 5 ? 5 : sizeVal;
                          },
                          symbol: 'roundRect',
                          data: data.map(function (item) {
                            return [item[1], item[0], item[2] || '-'];
                          }),
                          emphasis: {
                            itemStyle: {
                              shadowBlur: 10,
                              shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                          }
                        }]
                      };
                      option && myChart2.setOption(option, {
                        notMerge: true
                      });
                      let ddClick = this.drillkeyItem
                      myChart2.on('click', function (params) {
                        if (params.componentType === 'series' && params.data != undefined) {
                          let clickitem;
                          if (params.componentType == "yAxis") {
                            clickitem = {
                              "currpass": params.value + "~null",
                              "filterop": "Day~hour"
                            }
                          } else if (params.componentType == "xAxis") {
                            clickitem = {
                              "currpass": "null~" + params.value,
                              "filterop": "Day~hour"
                            }
                          } else if (params.componentType == "series") {
                            clickitem = {
                              "currpass": (parseInt(params.data[1]) + 1) + "~" + (parseInt(params.data[
                                0] +
                                1)),
                              "filterop": "Day~hour"
                            }
                          }
                          ddClick(clickitem, 1)
                        }
                      });
                    }
                  }, 100);
                } else if (condper == 3) {
                  this.mttadata = response.data.chrt_json.mttrdata
                  if (this.mttadata.length != 0 && this.mttadata[0].slaadherence == '-') {
                    this.isslaadherence = false
                  } else {
                    this.isslaadherence = true
                  }
                  setTimeout(() => {
                    this.drawsparkChrts("mtta", this.mttadata, this.isslaadherence);
                  }, 500);
                } else if (condper == 4) {
                  this.mttrdata = response.data.chrt_json.mttrdata
                  if (this.mttrdata.length != 0 && this.mttrdata[0].slaadherence == '-') {
                    this.isslaadherence = false
                  } else {
                    this.isslaadherence = true
                  }
                  setTimeout(() => {
                    this.drawsparkChrts("mttr", this.mttadata, this.isslaadherence);
                  }, 500);
                } else if (condper == 5) {
                  var slawholedata1 = response.data.chrt_json
                  if (slawholedata1 === undefined) {
                    return false
                  }
                  setTimeout(() => {
                    let chartDomSLA = document.getElementById('Chart5');
                    if (chartDomSLA != null && chartDomSLA != undefined) {
                      myChart5 = echarts.init(chartDomSLA);
                      let optionSLA = {
                        tooltip: {
                          confine: true,
                          trigger: 'axis',
                        },
                        legend: {
                          type: 'scroll',
                          textStyle: {
                            color: "inherit"
                          }
                        },
                        grid: {
                          left: 0,
                          top: 50,
                          right: '3%',
                          bottom: 20,
                          containLabel: true
                        },
                        xAxis: [{
                          type: 'category',
                          data: slawholedata1.Labels,
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        }],
                        yAxis: [{
                          type: 'value',
                          name: '# Tickets',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        },
                        {
                          type: 'value',
                          name: 'SLA Violation %',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777",
                            formatter: function (value, index) {
                              return value + '%';
                            }
                          },
                        }
                        ],
                        series: [{
                          name: 'Exceeded SLA',
                          type: 'bar',
                          data: slawholedata1.Bardata1,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(253, 55, 56, 1.0)'
                            }, {
                              offset: 1,
                              color: 'rgba(253, 55, 56, 0.4)'
                            }]),
                            borderColor: 'rgb(253, 55, 56)',
                            borderWidth: 1,
                            opacity: 1
                          },
                        },
                        {
                          name: 'Within SLA',
                          type: 'bar',
                          data: slawholedata1.Bardata2,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(54, 191, 54, 1.0)'
                            }, {
                              offset: 1,
                              color: 'rgba(54, 191, 54, 0.4)'
                            }]),
                            borderColor: 'rgb(54, 191, 54)',
                            borderWidth: 1,
                            opacity: 1
                          }
                        },
                        {
                          name: 'SLA Violation %',
                          type: 'line',
                          symbolSize: 8,
                          symbol: 'circle',
                          yAxisIndex: 1,
                          itemStyle: {
                            color: "rgba(184, 0, 0, 0.75)"
                          },
                          tooltip: {
                            confine: true,
                            valueFormatter: function (value) {
                              return value + ' %';
                            }
                          },
                          data: slawholedata1.linedata
                        }
                        ]
                      };
                      myChart5.setOption(optionSLA);
                      let ddClick = this.drillkeyItem
                      myChart5.on('click', function (params) {
                        if (params.componentType === 'series' && params.data != undefined) {
                          let clickitem = {
                            "currpass": params.seriesName + "~" + params.name,
                            "filterop": "SLA",
                            "splcond": "Response~All~0~1000000000000000000"
                          }
                          ddClick(clickitem, 2)
                        }
                      });
                    }
                  }, 100);
                } else if (condper == 6) {
                  var slawholedata2 = response.data.chrt_json
                  setTimeout(() => {
                    let chartDomSLA = document.getElementById('Chart6');
                    if (chartDomSLA != null && chartDomSLA != undefined) {
                      myChart6 = echarts.init(chartDomSLA);
                      let optionSLA = {
                        tooltip: {
                          confine: true,
                          trigger: 'axis',
                        },
                        legend: {
                          type: 'scroll',
                          textStyle: {
                            color: "inherit"
                          }
                        },
                        grid: {
                          left: 0,
                          top: 50,
                          right: '3%',
                          bottom: 20,
                          containLabel: true
                        },
                        xAxis: [{
                          type: 'category',
                          data: slawholedata2.Labels,
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        }],
                        yAxis: [{
                          type: 'value',
                          name: '# Tickets',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777"
                          },
                        },
                        {
                          type: 'value',
                          name: 'SLA Violation %',
                          nameTextStyle: {
                            fontSize: 10,
                            color: "#777"
                          },
                          splitLine: {
                            show: false
                          },
                          axisLine: {
                            show: true
                          },
                          axisLabel: {
                            fontSize: 10,
                            color: "#777",
                            formatter: function (value, index) {
                              return value + '%';
                            }
                          },
                        }
                        ],
                        series: [{
                          name: 'Exceeded SLA',
                          type: 'bar',
                          data: slawholedata2.Bardata1,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(253, 55, 56, 1.0)'
                            }, {
                              offset: 1,
                              color: 'rgba(253, 55, 56, 0.4)'
                            }]),
                            borderColor: 'rgb(253, 55, 56)',
                            borderWidth: 1,
                            opacity: 1
                          },
                        },
                        {
                          name: 'Within SLA',
                          type: 'bar',
                          data: slawholedata2.Bardata2,
                          itemStyle: {
                            borderRadius: 2,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                              offset: 0,
                              color: 'rgba(54, 191, 54, 1.0)'
                            }, {
                              offset: 1,
                              color: 'rgba(54, 191, 54, 0.4)'
                            }]),
                            borderColor: 'rgb(54, 191, 54)',
                            borderWidth: 1,
                            opacity: 1
                          }
                        },
                        {
                          name: 'SLA Violation %',
                          type: 'line',
                          symbolSize: 8,
                          symbol: 'circle',
                          yAxisIndex: 1,
                          itemStyle: {
                            color: "rgba(184, 0, 0, 0.75)"
                          },
                          tooltip: {
                            confine: true,
                            valueFormatter: function (value) {
                              return value + ' %';
                            }
                          },
                          data: slawholedata2.linedata
                        }
                        ]
                      };
                      myChart6.setOption(optionSLA);
                      let ddClick = this.drillkeyItem
                      myChart6.on('click', function (params) {
                        if (params.componentType === 'series' && params.data != undefined) {
                          let clickitem = {
                            "currpass": params.seriesName + "~" + params.name,
                            "filterop": "SLA",
                            "splcond": "Resolution~All~0~1000000000000000000"
                          }
                          ddClick(clickitem, 2)
                        }
                      });
                    }
                  }, 100);
                } else if (condper == 7) {
                  this.mttreopendata = response.data.chrt_json
                  let seriesArr = []
                  for (let index = 0; index < this.mttreopendata.monthlytrend.length; index++) {
                    const element = this.mttreopendata.monthlytrend[index];
                    seriesArr.push({
                      name: element.Request_Priority + " Reopened",
                      type: 'bar',
                      data: element.count,
                      itemStyle: {
                        borderRadius: 2,
                        color: this.myColorArray[index % 11],
                        borderColor: this.myBorderArray[index % 11],
                        borderWidth: 1,
                        opacity: 1
                      }
                    },)
                  }
                  setTimeout(() => {
                    let chartDomChart7 = document.getElementById('Chart7');
                    if (chartDomChart7 == null) {
                      return
                    }
                    myChart7 = echarts.init(chartDomChart7);
                    let option7 = {
                      tooltip: {
                        confine: true,
                        trigger: 'axis',
                      },
                      legend: {
                        type: 'scroll',
                        textStyle: {
                          color: "inherit"
                        }
                      },
                      grid: {
                        left: 30,
                        top: 30,
                        bottom: 30
                      },
                      xAxis: [{
                        type: 'category',
                        data: this.mttreopendata.Labels.Labels,
                        splitArea: {
                          show: false
                        },
                        splitLine: {
                          show: false
                        },
                        axisLine: {
                          show: true
                        },
                        axisLabel: {
                          fontSize: 10,
                          color: "#777"
                        },
                      }],
                      yAxis: [{
                        type: 'value',
                        nameTextStyle: {
                          fontSize: 10,
                          color: "#777"
                        },
                        splitArea: {
                          show: false
                        },
                        splitLine: {
                          show: false
                        },
                        axisLine: {
                          show: true
                        },
                        axisLabel: {
                          fontSize: 10,
                          color: "#777"
                        },
                      },],
                      series: seriesArr
                    };
                    myChart7.setOption(option7, {
                      notMerge: true
                    });
                    let ddClick = this.drillkeyItem
                    myChart7.on('click', function (params) {
                      if (params.componentType === 'series' && params.data != undefined) {
                        let clickitem = {
                          "currpass": params.seriesName + "~" + params.name,
                          "filterop": "ReopenedMonth",
                          "splcond": ""
                        }
                        ddClick(clickitem, 2)
                      }
                    });
                  }, 100);
                } else if (condper == 8) {
                  this.mttreassdata = response.data.chrt_json
                  let seriesArr = []
                  for (let index = 0; index < this.mttreassdata.monthlytrend.length; index++) {
                    const element = this.mttreassdata.monthlytrend[index];
                    seriesArr.push({
                      name: element.Request_Priority + " Hops",
                      type: 'bar',
                      data: element.count,
                      itemStyle: {
                        borderRadius: 2,
                        color: this.myColorArray[index % 11],
                        borderColor: this.myBorderArray[index % 11],
                        borderWidth: 1,
                        opacity: 1
                      }
                    },)
                  }
                  setTimeout(() => {
                    let chartDomChart8 = document.getElementById('Chart8');
                    if (chartDomChart8 == null) {
                      return
                    }
                    myChart8 = echarts.init(chartDomChart8);
                    let option8 = {
                      tooltip: {
                        trigger: 'axis',
                        confine: true
                      },
                      legend: {
                        type: 'scroll',
                        textStyle: {
                          color: "inherit"
                        }
                      },
                      grid: {
                        left: 30,
                        top: 30,
                        bottom: 30
                      },
                      xAxis: [{
                        type: 'category',
                        data: this.mttreassdata.Labels.Labels,
                        splitArea: {
                          show: false
                        },
                        splitLine: {
                          show: false
                        },
                        axisLine: {
                          show: true
                        },
                        axisLabel: {
                          fontSize: 10,
                          color: "#777"
                        },
                      }],
                      yAxis: [{
                        type: 'value',
                        nameTextStyle: {
                          fontSize: 10,
                          color: "#777"
                        },
                        splitArea: {
                          show: false
                        },
                        splitLine: {
                          show: false
                        },
                        axisLine: {
                          show: true
                        },
                        axisLabel: {
                          fontSize: 10,
                          color: "#777"
                        },
                      },],
                      series: seriesArr
                    };
                    myChart8.setOption(option8, {
                      notMerge: true
                    });
                    let ddClick = this.drillkeyItem
                    myChart8.on('click', function (params) {
                      if (params.componentType === 'series' && params.data != undefined) {
                        let clickitem = {
                          "currpass": params.seriesName + "~" + params.name,
                          "filterop": "ReassignedMonth",
                          "splcond": ""
                        }
                        ddClick(clickitem, 2)
                      }
                    });
                  }, 100);
                }
              } catch (error) {
                // console.log(error)
              }
            } else {
              this.keydrive[obsindex].chartNoData = response.data.desc;
            }
          } else if (response.data == "Error") {
            obsindex = this.keydrive.findIndex(x => x.order === condper)
            this.keydrive[obsindex].key_ins = "Error";
            this.keydrive[obsindex].dimcond = condper;
            foundIndex = this.keyInsightLoad.findIndex(x => x.where == condper);
            this.keyInsightLoad[foundIndex].show = false;
          }
          this.isLoadKeyDim = true;
        }).catch((error) => {
          this.keydrive[condper].isLoadKeyDim = true
          this.isLoadKeyDim = false
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Try after sometime!"
          })
          foundIndex = this.keyInsightLoad.findIndex(x => x.where == condper);
          this.keyInsightLoad[foundIndex].show = false;
        })
    },
    getKeyInsights(cond) {
      this.keyInsightLoad = []
      this.clickInsightLoad = true
      if (cond == 0) {
        this.isInsightloaded = false
      } else if (cond == 1) {
        this.isAnalysisloaded = false
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getcardview?asg_id=' + this.asgId + "&Cond=" + cond, {
        "selid": selectedId,
        "edited": this.showEdited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              var wholekeyIns = response.data
              this.keydrive = wholekeyIns.key_insight
              checkCount = response.data.key_insight
              this.loaderFixArr.push(checkCount)
              this.keyInsCard = wholekeyIns.cardInfo
              this.KITic_Count = this.keyInsCard.ticketcount
              var missing = new Array();
              var unavailkeyobs = [{
                'Ins_hdr': "Mean Time To Acknowledge",
                'key_ins': 'Nodata',
                'order': 3,
                'isLoadKeyDim': true,
                'desc': "Acknowledgement Time Analysis could not be generated due to missing 'Response Timestamp' or incorrect mapping in the source data."
              },
              {
                'Ins_hdr': "Mean Time To Resolve",
                'key_ins': 'Nodata',
                'order': 4,
                'isLoadKeyDim': true,
                'desc': "Resolution Time Analysis could not be generated due to missing 'Resolution Timestamp' or incorrect mapping in the source data."
              },
              {
                'Ins_hdr': "Acknowledgement SLA",
                'key_ins': 'Nodata',
                'order': 5,
                'isLoadKeyDim': true,
                'desc': "Acknowledgement(Response) SLA Analysis could not be generated due to missing 'Response SLA Met' or incorrect mapping in the source data."
              },
              {
                'Ins_hdr': "Resolution SLA",
                'key_ins': 'Nodata',
                'order': 6,
                'isLoadKeyDim': true,
                'desc': "Resolution SLA Analysis could not be generated due to missing 'Resolution SLA Met' or incorrect mapping in the source data."
              }, {
                'Ins_hdr': "Reopened",
                'key_ins': 'Nodata',
                'order': 7,
                'isLoadKeyDim': true,
                'desc': "Reopen Analysis could not be generated due to missing 'Reopen Count' or incorrect mapping in the source data."
              },
              {
                'Ins_hdr': "Reassignment",
                'key_ins': 'Nodata',
                'order': 8,
                'isLoadKeyDim': true,
                'desc': "Reassigned Analysis could not be generated due to missing 'Assignment Revised Count' or incorrect mapping in the source data."
              }
              ]
              for (var i = 0; i < 9; i++) {
                let obspos = this.keydrive.findIndex(x =>
                  x.order == i
                )
                if (obspos == -1) {
                  missing.push(i);
                  for (var j = 0; j < unavailkeyobs.length; j++) {
                    if (unavailkeyobs[j].order == i) {
                      this.keydrive.push(unavailkeyobs[j]);
                      break;
                    }
                  }
                }
              }
              if (this.isTab1) {
                for (let i = 0; i < this.keydrive.length; i++) {
                  if (this.keydrive[i].key_ins != "Nodata") {
                    this.getKey_dim(cond, this.keydrive[i].order)
                  }
                }
              }
              if (cond == 1) {
                this.$notify({
                  type: "success",
                  text: "Analysis successful."
                })
              } else if (cond == 0) {
                this.$notify({
                  type: "success",
                  text: "Loaded successfully."
                })
              }
              this.isInsightloaded = true
              this.isAnalysisloaded = true
              this.clickInsightLoad = false;
              if(this.isViewChange == 3){
                this.chartVisbility(7)
                setTimeout(() => {
                  this.chartVisbility(this.storeTabselected)
                  this.isViewChange = null
                }, 0);
              }

            } else {
              this.isInsightloaded = true
              this.isAnalysisloaded = true
              this.clickInsightLoad = false;
              this.$notify({
                type: "error",
                text: "Sorry! Something went wrong. Try after sometime!"
              })
            }
          }
        }).catch((error) => {
          this.isInsightloaded = true
          this.isAnalysisloaded = true
          this.clickInsightLoad = false;
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    removePortBlank() {
      let port_blankModify = JSON.parse(JSON.stringify(port_nBlank.slice(0)));
      if (this.isRemoveBlank == true) {
        for (var i = 0; i < port_blankModify.length; i++) {
          if (port_blankModify[i].category_head == "(Blanks)") {
            port_blankModify.splice(i, 1)
            i--
          } else {
            for (var j = 0; j < port_blankModify[i].sub_list.length; j++) {
              if (port_blankModify[i].sub_list[j].sub_name == "(Blanks)") {
                port_blankModify[i].sub_list.splice(j, 1)
                j--
              }
            }
          }
        }
      } else {
        for (var k = 0; k < port_blankModify.length; k++) {
          if (port_blankModify[k].sub_list.length > 6) {
            if (port_blankModify[k].sub_list[6].sub_name == "(OTHERS)") {
              var sum_per = parseFloat(port_blankModify[k].sub_list[5].sub_per) + parseFloat(port_blankModify[k]
                .sub_list[6].sub_per)
              port_blankModify[k].sub_list[6].sub_per = sum_per.toFixed(1).toString()
              port_blankModify[k].sub_list.splice(5, 1)
            }
          }
        }
      }
      this.wholePortdata = JSON.parse(JSON.stringify(port_blankModify.slice(0)));
    },
    getcategorydrop() {
      this.isInsightloaded = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfolio?asg_id=' + this.asgId + "&Cond=" + 0, {
        "selid": selectedId,
        "edited": this.showEdited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error") {
              var wholedropsdata = response.data
              let wholePort = wholedropsdata.overallport.portdata
              this.isMTTRPresent = wholedropsdata.overallport.ispresent
              port_nBlank = wholePort.slice(0)
              this.catop = wholedropsdata.groupin
              this.splitop = wholedropsdata.splitin
              this.isportError = true
              port_nBlank = wholePort.slice(0)
              this.removePortBlank()
              this.loadPortfolioDD()
            } else {
              this.isportError = false
              this.$notify({
                type: "error",
                text: "Sorry! Something went Wrong! Please try again after few minutes"
              })
            }
          }
          this.isInsightloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    genPortfolio() {
      if (this.catop.dbname == this.splitop.dbname) {
        this.$notify({
          type: "warn",
          text: 'Sorry! Filter levels cannot contain Same Filters. Try with different Filters!'
        })
        return
      }
      this.isInsightloaded = false
      var portdata = ({
        "Category": this.catop.dbname,
        "split": this.splitop.dbname,
        "selid": selectedId,
        "edited": this.showEdited
      })
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfolio?asg_id=' + this.asgId + "&Cond=" + 1,
        portdata,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error") {
              var whole_port = response.data
              this.isportError = true
              this.isMTTRPresent = whole_port.ispresent
              port_nBlank = whole_port.portdata.slice(0)
              this.$notify({
                type: "success",
                text: "Portfolio Generated successfully."
              })
              this.removePortBlank()
            } else {
              this.$notify({
                type: "error",
                text: "Sorry! Something went Wrong! Please try again after few minutes"
              })
              this.isportError = false
            }
          }
          this.isInsightloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    checkEmpty(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].filter_key == "" || arr[i].filter_vals.length == 0)
          return true;
      }
      return false;
    },
    checkDuplicate(arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = 1; j < arr.length; j++) {
          if (i !== j) {
            if (arr[i].filter_key == arr[j].filter_key) {
              return true;
            }
          }
        }
      }
      return false;
    },
    rename_view(id, name) {
      this.true;
      this.$refs.renameViewMd.showReviewModal(id, name)
    },
    viewsetting(cond, id, name) {
      var resp, erresp
      var pindata = ({
        "viewname": name,
        "viewid": id
      })
      if (cond == 0) {
        resp = "deleted"
        erresp = "delete"
        this.isDeleteSuccessful = false;
      } else {
        resp = "renamed"
        erresp = "rename"
      }
      this.isInsightloaded = false
      this.axios.post(this.uriApiUrl + 'UserSetting/view_setting?asg_id=' + this.asgId + "&cond=" + cond,
        pindata,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          var tempIndex
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Fail" && response.data != "denied,") {
              if (cond == 0) {
                for (let i = 0; i < this.savedSettings.length; i++) {
                  if (this.savedSettings[i].id == id) {
                    tempIndex = i
                    if (this.savedSettings[i].issel) {
                      this.showEdited = true
                    }
                  }
                  selectedId = ""
                }
                this.savedSettings.splice(tempIndex, 1)
                this.loadedView == name ? this.loadedView = "Untitled" : true
                this.showDeleteModal = false
                this.$notify({
                  type: "success",
                  text: 'view has been ' + resp + ' successfully.'
                })
                this.isDeleteSuccessful = true;
              } else {
                if (response.data == "Exists") {
                  this.isExist = true
                }
                else if(response.data == "Invalidinput") {
                  this.$notify({
                    type: "warning",
                    text: "View Name Should not contain special characters",
                  })
                }
                else {
                  for (let i = 0; i < this.savedSettings.length; i++) {
                    if (this.savedSettings[i].id == id) {
                      this.savedSettings[i].name = name
                    }
                  }
                  this.loadedView = name
                  this.$notify({
                    type: "success",
                    text: 'view has been ' + erresp + ' successfully.'
                  })
                  this.$refs.renameViewMd.close();
                }
              }
              this.getViewList(false)
            } else {
                  this.$notify({
                  type: "error",
                  text: 'Sorry! Something went Wrong! Please try again after few minutes'
              })
            }
          }
          this.isInsightloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    okDeleteView() {
      this.viewsetting(0, selectedId, selectedName)
    },
    deleteView(id, name) {
      selectedId = id
      selectedName = name
      this.showDeleteModal = true
      this.selectedDelName = name
    },
    mySavedViewClick(event, valID, valName) {
      selectedId = valID
      selectedName = valName
      this.loadedView = valName
      this.showEdited = false
      this.isViewChange = 3;
      this.storeTabselected = this.tabsel
      this.getAnalyse(3)
    },
    showHidePanel() {
      this.isShowSaved = !this.isShowSaved
    },
    loadPortVals(fltrname, pos) {
      if (fltrname != null) {
        this.isInsightloaded = false
        this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfilter?asg_id=' + this.asgId, {
          filtername: fltrname.dbname
        },{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              if (response.data != "Error") {
                let wholeFilter = response.data
                this.portlevels[pos].filter_vals = []
                this.portlevels[pos].filter_ops = [{
                  header: "Values",
                  valF: wholeFilter
                }]
              } else {
                this.$notify({
                  type: "error",
                  text: 'Sorry! Something went Wrong! Please try again after few minutes'
                })
              }
            }
            this.isInsightloaded = true
          }).catch((error) => {
            this.isInsightloaded = true
            this.$notify({
              type: "error",
              text: "Sorry! Something went Wrong! Please try again after few minutes"
            })
          })
      }
    },
    modifyPortLvl(index, val) {
      if (val == 0) {
        if (index < 4) {
          this.portlevels.push({
            filter_key: null,
            filter_vals: [],
            filter_ops: []
          })
        } else {
          this.$notify({
            type: "warning",
            text: 'You cannot add more then 5 filters!'
          })
        }
      } else if (val == 1) {
        this.portlevels.splice(index, 1)
      } else {
        this.portlevels.push({
          filter_key: null,
          filter_vals: [],
          filter_ops: []
        });
      }
    },
    loadPortfolioDD() {
      this.catop = this.AnalysisOns.find(element => element.dbname == this.catop)
      this.splitop = this.AnalysisOns.find(element => element.dbname == this.splitop)
    },
    resetDate(pos) {
      if (pos == 0) {
        let resetst = insightInfo.AsgstartDate.split('|')[1]
        resetst = resetst.split('-')
        this.startdt = new Date(resetst[0], resetst[1] - 1, resetst[2])
      } else {
        let resetend = insightInfo.AsgendDate.split('|')[1]
        resetend = resetend.split('-')
        this.enddt = new Date(resetend[0], resetend[1] - 1, resetend[2])
      }
    },
    selectWidget(val) {
      for (let index = 0; index < this.widgetHolder.length; index++) {
        var element = this.widgetHolder[index]
        if (element.wgtid == val) {
          return element.wgt_comp
        }
      }
    },
    drawChangeChart(changeChartType) {
      this.isTab1 = false;
      this.tabsel = 8
      changeCust = "reset"
      if (changeCC == changeChartType) {
        return false
      }
      changeCC = changeChartType
      this.showFilterIcon = false
      this.showRespCard = false
      this.showResolCard = false
      this.showReopenCard = false
      this.showReassgCard = false
      this.showPcards = false
      this.selection = "Ischanged"
      this.showFilterIcon = false
      this.chartNo = 3
      let getsnapdiv = document.querySelectorAll('.chnage-tab-btn-group .changeButton');
      for (var i = 0; i < getsnapdiv.length; i++) {
        getsnapdiv[i].classList.remove('themeclr');
      }
      switch (changeChartType) {
        case 1:
          this.changePassdata = this.getBump
          this.bumpChartShow = true
          getsnapdiv = document.querySelectorAll('.chnage-tab-btn-group .changeButton:nth-child(1)')
          getsnapdiv[0].classList.add("themeclr")
          this.changedwgtTemp = this.selectWidget(18)
          break
        case 3:
          this.changePassdata = this.getWF
          this.bumpChartShow = false
          getsnapdiv = document.querySelectorAll('.chnage-tab-btn-group .changeButton:nth-child(2)')
          getsnapdiv[0].classList.add("themeclr")
          this.changedwgtTemp = this.selectWidget(20)
          break
        default:
          break
      }
    },
    drawFancyChart(ChartType) {
      this.isTab1 = false;
      this.tabsel = 9
      this.chartNo = 4
      changeCC = "reset"
      if (changeCust == ChartType) {
        return false
      }
      changeCust = ChartType
      this.showFilterIcon = false
      this.showRespCard = false
      this.showResolCard = false
      this.showReopenCard = false
      this.showReassgCard = false
      this.showPcards = false
      this.selection = "custom"
      this.showFilterIcon = false
      geticondiv = document.querySelectorAll('.fancyButton')
      geticondiv.forEach(box => {
        box.classList.remove("themeclr")
      });
      switch (ChartType) {
        case 1:
          this.custview = this.selectWidget(14)
          geticondiv = document.querySelectorAll('.fancyButton:nth-child(1)')
          geticondiv.forEach(box => {
            box.classList.add("themeclr")
          });
          break
        case 2:
          this.custview = this.selectWidget(15)
          geticondiv = document.querySelectorAll('.fancyButton:nth-child(2)')
          geticondiv.forEach(box => {
            box.classList.add("themeclr")
          });
          break
        case 3:
          this.custview = this.selectWidget(16)
          geticondiv = document.querySelectorAll('.fancyButton:nth-child(1)')
          geticondiv.forEach(box => {
            box.classList.add("themeclr")
          });
          break
        case 4:
          this.custview = this.selectWidget(17)
          geticondiv = document.querySelectorAll('.fancyButton:nth-child(1)')
          geticondiv.forEach(box => {
            box.classList.add("themeclr")
          });
          break
        case 5:
          this.custview = this.selectWidget(21)
          geticondiv = document.querySelectorAll('.fancyButton:nth-child(3)')
          geticondiv.forEach(box => {
            box.classList.add("themeclr")
          });
          break
        default:
          break
      }
    },
    getAnalyse(val) {
      var WCFilteron = []
      var bubbleFilteron = []
      var bumpFilteron = []
      var WFfilteron = []
      cond = 11
      var sendAnalyse = {}
      var priorsnd, viewid
      switch (val) {
        case 0:
          this.isInsightloaded = false
          cond = 0
          sendAnalyse = ({
            "edited": this.showEdited
          })
          selectedId = ""
          var showEdited = false
          selectedName = ""
          viewNameV = ""
          break;
        case 3:
          this.isInsightloaded = false
          cond = 3
          sendAnalyse = ({
            "selid": selectedId,
            "edited": showEdited
          })
          break;
        case 1:
          var curDate = new Date()
          if (this.AnalysisOp.dbname == this.ins_priorLv2op.dbname) {
            this.$notify({
              type: "warn",
              text: 'The First Level and Second Level Analysis can\'t be the same '
            })
            return false
          }
          if (this.startdt > this.enddt) {
            this.$notify({
              type: "warn",
              text: 'Sorry! End Date should be greater than start date!'
            })
            return false
          }
          if (this.startdt > curDate) {
            this.$notify({
              type: "warn",
              text: 'Sorry! Start date should be before today.'
            })
            return false
          }
          if (this.portlevels.length != 0) {
            priorsnd = this.filterLevelConv(false);
            var emptyChk = this.checkEmpty(priorsnd)
            var isDuplicate = this.checkDuplicate(priorsnd)
          } else {
            priorsnd = []
          }
          if (emptyChk) {
            this.$notify({
              type: "warn",
              text: 'Sorry! Filters cannot be empty'
            })
            priorsnd = this.filterLevelConv(true);
            return false
          } else if (isDuplicate) {
            this.$notify({
              type: "warn",
              text: 'Sorry! Filter levels cannot contain Same Filters. Try with different Filters!'
            })
            priorsnd = this.filterLevelConv(true);
            return false
          }
          cond = 1
          this.timeZoneArrConv(false)
          this.isAnalysisloaded = false
          sendAnalyse = ({
            "isSave": val == 2 ? true : false,
            "view_name": viewNameV,
            "selid": selectedId,
            "edited": showEdited,
            "analyseon": this.AnalysisOp.dbname,
            "prior_op": priorsnd,
            "timezone": this.timeZone,
            "startDate": this.startdt == null ? null : moment(this.startdt).format(
              'YYYY-MM-DD'),
            "endDate": this.enddt == null ? null : moment(this.enddt).format('YYYY-MM-DD'),
            "lv2_prior_ins": this.ins_priorLv2op.dbname
          })
          if (getcolumnprior != undefined & getcolumnprior.length != 0) {
            sendAnalyse.gud_filt_Lis = this.getgudLis
            sendAnalyse.non_gud_filt_Lis = this.getnongudLis
          }
          this.isadvSets = false
          this.showWrapper = false
          break;
        case 2:
          this.isInsightloaded = false
          if (this.portlevels.length != 0) {
            priorsnd = this.filterLevelConv(false);
            var emptyChk_two = this.checkEmpty(priorsnd)
            var isDuplicate_two = this.checkDuplicate(priorsnd)
          } else {
            priorsnd = []
          }
          if (emptyChk_two) {
            this.$notify({
              type: "warn",
              text: 'Sorry! Filters cannot be empty'
            })
          } else if (isDuplicate_two) {
            this.$notify({
              type: "warn",
              text: 'Sorry! Filter levels cannot contain Same Filters. Try with different Filters!'
            })
          } else {
            cond = 1
            var curDate_two = new Date()
            if (this.startdt > this.enddt) {
              this.$notify({
                type: "warn",
                text: 'Sorry! End Date should be greater than start date!'
              })
              return false
            }
            if (this.startdt > curDate_two) {
              this.$notify({
                type: "warn",
                text: 'Sorry! Start date should be before today.'
              })
              return false
            } else {
              this.timeZoneArrConv(false)
              sendAnalyse = ({
                "isSave": val == 2 ? true : false,
                "view_name": viewNameV,
                "selid": selectedId,
                "edited": showEdited,
                "analyseon": this.AnalysisOp.dbname,
                "prior_op": priorsnd,
                "timezone": this.timeZone,
                "startDate": this.startdt == null ? null : moment(this.startdt).format(
                  'YYYY-MM-DD'),
                "endDate": this.enddt == null ? null : moment(this.enddt).format(
                  'YYYY-MM-DD'),
                "lv2_prior_ins": this.ins_priorLv2op.dbname
              })
              if (getcolumnprior != undefined & getcolumnprior.length != 0) {
                sendAnalyse.gud_filt_Lis = this.getgudLis
                sendAnalyse.non_gud_filt_Lis = this.getnongudLis
              }
            }
          }
          break;
        default:
          break;
      }
      if (cond != 11) {
        this.axios.post(this.uriApiUrl + 'DataAnalysis/generateloinsights?asg_id=' + this.asgId + '&Cond=' +
          cond,
          sendAnalyse,{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              this.isadvSets = false;
              this.Is_bookmark = this.$store.state.Is_bookmark;
              this.AsgName = this.$store.state.AsgName;
              this.isOwner = this.$store.state.isOwner;
              if (response.data != "Error" && response.data != "404" && response.data != "403") {
                this.showWrapper = false
                if (val != 1) {
                  this.showEdited = false
                }
                if (val == 2) {
                  viewid = response.data
                  if (!this.allViews.includes(viewid)) {
                    this.savedSettings.push({
                      "name": viewNameV,
                      "id": viewid,
                      "issel": true,
                      "isOwner": true
                    })
                    this.bookmarkview(null, viewid, true, false)
                  }
                  if (viewid != selectedId) {
                    for (let i = 0; i < this.savedSettings.length; i++) {
                      if (this.savedSettings[i].id == viewid) {
                        this.savedSettings[i].issel = true
                      } else {
                        this.savedSettings[i].issel = false
                      }
                    }
                  }
                  this.timeZone = insightInfo.timezone
                  this.timeZoneArrConv(true);
                  if (insightInfo.prior_op.length != 0) {
                    this.portlevels = JSON.parse(JSON.stringify(insightInfo.prior_op.slice(0)));
                    this.filterLevelConv(true);
                  }
                  selectedId = viewid
                  this.loadedView = viewNameV
                  this.savePopShow = false
                  this.$notify({
                    type: "success",
                    text: "View Saved Successfully."
                  })
                  this.lzeroshow = false
                  this.loneshow = true
                } else {
                  this.lzeroshow = false
                  this.loneshow = true
                  insightInfo = response.data
                  this.$sessionData.set('insightInfoGlobal', insightInfo)
                  this.startdt = insightInfo.startdate
                  this.savedSettings = insightInfo.view_lis
                  this.allViews = []
                  for (let index = 0; index < this.savedSettings.length; index++) {
                    const element = this.savedSettings[index];
                    this.allViews.push(element.id)
                  }
                  this.timeZone = insightInfo.timezone
                  this.timeZoneArrConv(true);
                  if (insightInfo.curr_view.length > 0) {
                    selectedId = insightInfo.curr_view[0]
                    this.loadedView = insightInfo.curr_view[1]
                    selectedName = insightInfo.curr_view[1]
                  }
                  this.initialStart = insightInfo.AsgstartDate.split('|')[0]
                  this.initialEnd = insightInfo.AsgendDate.split('|')[0]
                  if (this.startdt != null) {
                    var strtdate = this.startdt.split('-')
                    this.startdt = new Date(strtdate[0], strtdate[1] - 1, strtdate[2])
                  }
                  this.enddt = insightInfo.enddate
                  if (this.enddt != null) {
                    var enddate = this.enddt.split('-')
                    this.enddt = new Date(enddate[0], enddate[1] - 1, enddate[2])
                  }
                  this.AnalysisOns = insightInfo.dropdata
                  this.AnalysisOp = this.AnalysisOns.find(element => element.ticked == true)
                  this.getdropsdata = Object.assign([], insightInfo.dropdata)
                  if (insightInfo.prior_op.length != 0) {
                    this.portlevels = JSON.parse(JSON.stringify(insightInfo.prior_op.slice(0)));
                    this.filterLevelConv(true);
                  } else {
                    this.portlevels = []
                  }
                  this.catop = insightInfo.analysison[0].dbname
                  this.splitop = insightInfo.lv2_prior_ins
                  this.loadPortfolioDD()
                  WCFilteron = Object.assign([], insightInfo.dropdata)
                  bumpFilteron = Object.assign([], insightInfo.dropdata)
                  WFfilteron = Object.assign([], insightInfo.dropdata)
                  bubbleFilteron = Object.assign([], insightInfo.dropdata)
                  this.getWc = {
                    WCFilteron: WCFilteron,
                    selection: this.selection
                  }
                  this.getBubble = {
                    bubbleFilteron: bubbleFilteron,
                    selection: this.selection
                  }
                  changeOp = insightInfo.analysison
                  this.getBump = {
                    bumpFilteron: bumpFilteron,
                    selection: this.selection,
                    changeOp: changeOp
                  }
                  this.getWF = {
                    WFfilteron: WFfilteron,
                    selection: this.selection,
                    changeOp: changeOp
                  }
                  this.getCard = insightInfo.cardInfo
                  this.ticketcount = this.getCard.ticketcount
                  this.p1_Tic_count = this.getCard.p1_type_filt_count
                  this.p1_perc = this.getCard.p1_type_filt_perc
                  this.prior_list = insightInfo.rangein.dis_prior
                  enabledWidgetsLst = [];
                  for (let index = 0; index < insightInfo.enabled.length; index++) {
                    const element = insightInfo.enabled[index];
                    let wgtload = []
                    for (let index1 = 0; index1 < element.widget.length; index1++) {
                      const element1 = element.widget[index1];
                      let foundVar = widgetHolder.filter(function (itm) {
                        return itm.wgtid == element1;
                      })[0];
                      if (foundVar.wgt_name == "WordCloud") {
                        wgtload.push({
                          "wgt": foundVar.wgt_name,
                          "passdata": this.getWc
                        })
                      } else if (foundVar.wgt_name == "BubbleTrend") {
                        wgtload.push({
                          "wgt": foundVar.wgt_name,
                          "passdata": this.getBubble
                        })
                      } else {
                        wgtload.push({
                          "wgt": foundVar.wgt_name,
                          "passdata": ""
                        })
                      }
                    }
                    enabledWidgetsLst.push({
                      "wgtload": wgtload
                    })
                  }
                  this.widgetInfo = insightInfo.widget_info
                  let lv2name = WFfilteron.find(element => element.dbname == insightInfo.lv2_prior_ins)
                  this.ins_priorLv2op = lv2name
                  this.l2dispname = lv2name.name
                  getcolumnprior = insightInfo.col_filter
                  this.passpinInfo = {
                    "selid": selectedId,
                    "edited": this.showEdited,
                    "get_prior": this.get_prior,
                    "viewName": this.loadedView
                  }
                  let tabCount = 5
                  if (this.getCard.Resp_Tic_count != "Nodata") {
                    tabCount++
                  }
                  if (this.getCard.Resol_Tic_Count != "Nodata") {
                    tabCount++
                  }
                  if (this.getCard.Reopen_Tic_count != "Nodata") {
                    tabCount++
                  }
                  if (this.getCard.Reassign_Tic_count != "Nodata") {
                    tabCount++
                  }
                  switch (tabCount) {
                    case 5:
                      this.myTabWidthH = "myTabWidth5"
                      break
                    case 6:
                      this.myTabWidthH = "myTabWidth6"
                      break
                    case 7:
                      this.myTabWidthH = "myTabWidth7"
                      break
                    case 8:
                      this.myTabWidthH = "myTabWidth8"
                      break
                    case 9:
                      this.myTabWidthH = "myTabWidth9"
                      break
                    default:
                      break
                  }
                  if (insightInfo.col_filter.length != 0) {
                    this.getgudLis = getcolumnprior.gud_filt
                    this.getnongudLis = getcolumnprior.non_gud_filt
                    this.getcolumnpriorToChild = getcolumnprior
                    this.getcolumnpriorToChild.selectedId = selectedId
                  }
                  if (this.getCard.ticketcount <= 25) {
                    this.isInsOn = true
                    this.isadvSets = false
                    this.isadvSetsDrill = false
                  } else {
                    this.isadvSetsDrill = true
                    this.isInsOn = false
                    if (this.tabno == "tab-1") {
                      if (this.selection == "Ischanged") {
                        changeCC = "reset"
                        this.chartVisbility(8)
                      } else if (this.selection == "custom") {
                        changeCust = "reset"
                        this.chartVisbility(9)
                      } else if (typeof (this.selection) == "number") {
                        this.chartVisbility(this.selection)
                      } else {
                        this.chartVisbility(7)
                      }
                    }
                    this.getKeyInsights(cond)
                  }
                }
              } else if (response.data == "Error") {
                this.$notify({
                  type: "error",
                  text: 'Sorry! Could not Analyze. Try after sometime!'
                })
                if (cond == 1) {
                  this.isadvSets = true
                  this.showWrapper = true
                }
              } else if (response.data == "403") {
                this.$sessionData.set('pgresp', response.data)
                this.$router.push('/Page404')
                this.$notify({
                  type: "error",
                  text: 'Sorry! you dont have an access!'
                })
              }
            } else if (response.data == "Error") {
              this.isInsightloaded = true
              this.isAnalysisloaded = true
              this.$notify({
                type: "error",
                text: 'Sorry! Could not Analyze. Try after sometime!'
              })
              if (cond == 1) {
                this.isadvSets = true
                this.showWrapper = true
              }
            }
            this.isInsightloaded = true
            this.isAnalysisloaded = true
          }).catch((error) => {
            this.isInsightloaded = true
            this.isAnalysisloaded = true
            if (error.status == 504) {
              this.$notify({
                type: "error",
                text: 'Connection Timeout Issue. Kindly Contact Support Team.'
              })
            } else if (error.status == 406) {
              this.$notify({
                type: "error",
                text: 'Your File Has Been Blocked at WAF Level. Kindly Contact Support Team.'
              })
            } else {
              this.$notify({
                type: "error",
                text: "Sorry! Could not Analyze. Try after sometime!"
              })
            }
          })
      }
    },
    undoSetting() {
      this.showWrapper = false;
      this.startdt = insightInfo.startdate;
      this.savedSettings = insightInfo.view_lis;
      if (insightInfo.curr_view.length > 0) {
        this.selectedId = insightInfo.curr_view[0];
        this.loadedView = insightInfo.curr_view[1];
      }
      this.initialStart = insightInfo.AsgstartDate.split('|')[0];
      this.initialEnd = insightInfo.AsgendDate.split('|')[0];
      if (this.startdt != null) {
        var strtdate = this.startdt.split('-');
        this.startdt = new Date(strtdate[0], strtdate[1] - 1, strtdate[2]);
      }
      this.enddt = insightInfo.enddate;
      if (this.enddt != null) {
        var enddate = this.enddt.split('-');
        this.enddt = new Date(enddate[0], enddate[1] - 1, enddate[2]);
      }
      this.AnalysisOp = this.AnalysisOns.find(element => element.ticked == true)
      this.ins_priorLv2op = this.AnalysisOns.find(element => element.dbname == insightInfo.lv2_prior_ins)
      this.timeZone = insightInfo.timezone;
      this.timeZoneArrConv(true);
      if (insightInfo.prior_op.length != 0) {
        this.portlevels = JSON.parse(JSON.stringify(insightInfo.prior_op.slice(0)));
        this.filterLevelConv(true);
      } else {
        this.portlevels = []
      }
      this.showEdited = false;
    },
    showSettings() {
      this.showAsmtSettingsIn = true;
      this.settingLoader = true
      this.axios.get(this.uriApiUrl + 'UserSetting/getassessment?asg_id=' + this.asgId + "&Cond=" + 1,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data == "Error") {
            this.$notify({
              type: "error",
              text: 'Sorry not able to load the assessment! Please retry and if you still face issues contact the support team'
            })
          } else if (response.data == "404") {
            sessionStorage.pgResp = response.data;
            this.$router.push('/Page404')
            this.$notify({
              type: "error",
              text: 'Sorry! No Assessment exists !'
            })
          } else if (response.data == "403") {
            sessionStorage.pgResp = response.data;
            this.$router.push('/Page404')
            this.$notify({
              type: "error",
              text: 'Sorry! you dont have an access!'
            })
          } else {
            this.setupinfo = response.data;
            this.asgOwner = this.setupinfo.owner;
            this.isWrShare = this.setupinfo.Wr_Acc
            this.sharecond = this.setupinfo.shareset;
            this.we_mode = this.setupinfo.we_config;
            this.getscorelbls = this.setupinfo.type_inqui.typesets;
            this.getcriticPrior = this.setupinfo.critic_val
            this.priorityOrder = this.setupinfo.prior_order.split('~')
            for (let index = 0; index < this.getscorelbls.length; index++) {
              const element = this.getscorelbls[index];
              element.value = []
              for (let indexI = 0; indexI < element.opt.length; indexI++) {
                const elementI = element.opt[indexI];
                if (elementI.ticked) {
                  element.value.push(elementI)
                }
              }
            }
            if (this.getscorelbls) {
              this.isImport = this.setupinfo.type_inqui.is_import;
              this.isDataPattern = this.setupinfo.type_inqui.isAsg_type;
              this.iss_drops = this.setupinfo.type_inqui.inquiIss_drops;
              this.sol_drops = this.setupinfo.type_inqui.inquiSol_drops;
              this.assgn_drops = this.setupinfo.type_inqui.inquiAssgn_drops;
              this.inquiIssop = this.setupinfo.type_inqui.inqui_issue
              this.inquiSolop = this.setupinfo.type_inqui.inqui_sol
              this.inquiAssgnop = this.setupinfo.type_inqui.inqui_assignee
              if (this.setupinfo.owner == 'Y') {
                this.isOwner = true
              }
              if (this.setupinfo.critic_val != 0) {
                this.criticalVal = this.setupinfo.critic_val.critic
                this.noncriticalVal = this.setupinfo.critic_val.noncritic
              }
            }
          }
          setTimeout(() => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          }, 200);
          this.settingLoader = false
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: "Connection Issue! Please try again."
          })
          this.settingLoader = false
        })
    },
    get_prior_sel(prior_tab, childNo) {
      childNo++;
      geticondiv = document.querySelectorAll('.grpBtn3')
      geticondiv.forEach(box => {
        box.classList.remove("themeclr")
      });
      this.get_prior = prior_tab;
      this.chartVisbility(this.selection);
      geticondiv = document.querySelectorAll('.grpBtn3:nth-child(' + childNo + ')')
      geticondiv.forEach(box => {
        box.classList.add("themeclr")
      });
    },
    switchMtab() {
      this.tabno = "tab-1"
      this.isTab1 = false
      if (this.selection == "Ischanged") {
        this.chartVisbility(8)
      } else if (this.selection == "custom") {
        this.chartVisbility(9);
      } else if (typeof (this.selection) == "number") {
        setTimeout(() => {
          this.chartVisbility(this.selection);
        }, 100);
      } else {
        this.chartVisbility(7);
      }
    },
    replaceBar(liItem, index, inspos, optVal) {
      let splitString = liItem.split('|')
      let eachLink = []
      let link = []
      for (let item = 1; item < splitString.length; item++) {
        let filterop = ''
        eachLink.push(splitString[item].split('~').join('</a>'));
        let removeSecondBracket = splitString[item].split('~')[0]
        removeSecondBracket = removeSecondBracket.split(')')[0]
        link.push("<a class='primaryTxt KDtxt' href='#id=" + item + "&currpass=" + removeSecondBracket +
          "&filterop=" +
          filterop + "&kpos=" + index + "&optVal=" + optVal + "&inspos=" + inspos + "&type=keyDrill'>")
        splitString.join('<a>' + splitString[item].split('~')[0] + '</a>')
      }
      let result = splitString[0];
      for (let i = 0; i < link.length; i++) {
        result += link[i] + eachLink[i]
      }
      if (liItem.includes("trend") || liItem.includes("Trend")) {
        var type = "fail";
        if (liItem.includes("Backlog")) {
          type = "Backlog~"
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("Resolution Rate")) {
          type = "Resolution Rate~"
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("Incoming")) {
          type = "Incoming~"
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("Response") && liItem.includes("SLA Violation %")) {
          type = "Response SLA Violation %~"
          type += liItem.split('Response').pop().split('SLA')[0].trim() + "~";
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("exceeded Response SLAs")) {
          type = "exceeded Response SLAs~"
          type += liItem.split('seen in').pop().split('tickets')[0].trim();
        } else if (liItem.includes("met Response SLAs")) {
          type = "met Response SLAs~"
          type += liItem.split('seen in').pop().split('tickets')[0].trim();
        } else if (liItem.includes("Resolution") && liItem.includes("SLA Violation %")) {
          type = "Resolution SLA Violation %~"
          type += liItem.split('Resolution').pop().split('SLA')[0].trim() + "~";
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("exceeded Resolution SLAs")) {
          type = "exceeded Resolution SLAs~"
          type += liItem.split('seen in').pop().split('tickets')[0].trim();
        } else if (liItem.includes("met Resolution SLAs")) {
          type = "met Resolution SLAs~"
          type += liItem.split('seen in').pop().split('tickets')[0].trim();
        } else if (liItem.includes("Reopened")) {
          type = "Reopened~"
          type += liItem.split('Reopened').pop().split('tickets')[0].trim();
        } else if (liItem.includes("Reassigned")) {
          type = "Reassigned~"
          type += liItem.split('Reassigned').pop().split('tickets')[0].trim();
        } else if (liItem.includes("MTTR")) {
          type = "MTTR~"
          type += liItem.split('seen in').pop().split('MTTR')[0].trim() + "~";
          type += liItem.split(' ')[1].trim().toLowerCase();
        } else if (liItem.includes("MTTA")) {
          type = "MTTA~"
          type += liItem.split('seen in').pop().split('MTTA')[0].trim() + "~";
          type += liItem.split(' ')[1].trim().toLowerCase();
        }
        var funcCrt = type.trim();
        result += '. <a class="primaryTxt KDtxt" href="#id=0&currpass=' + funcCrt +
          '&type=getExplain">Explain </a>'
      }
      return result
    },
    getQueryParams(params) {
      let href = window.location.href;
      let regexp = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
      let qString = regexp.exec(href);
      return qString ? qString[1] : null;
    },
    getwidgetrange() {
      this.clickInsightLoad = true
      var range = ({
        "minrange": this.slider.minValue,
        "maxrange": this.slider.maxValue,
        "selid": selectedId,
        "edited": this.showEdited
      });
      if (this.slider.maxValue == 0) {
        this.$notify({
          type: "warning",
          text: 'Sorry! Max Range cannot be 0',
        })
        return false;
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getwidgetrange?asg_id=' + this.asgId + "&seltype=" + this
        .selection, range,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data != "Error" && response.data != "Nodata") {
            var updateCount = response.data;
            if (this.selection == 2) {
              this.selvalue = "resp_range";
              this.getCard.Resp_Tab_Tic_count = updateCount.overallTicket
              this.getCard.Resptabadher = updateCount.other_perc;
              this.getCard.Resp_adher_count = updateCount.other_count;
              this.getCard.resp_range_p1perc = updateCount.p1_perc;
              this.getCard.resp_range_p1count = updateCount.p1_count;
              this.FilterTic_Count = updateCount.overallTicket;
            }
            if (this.selection == 3) {
              this.selvalue = "resol_range";
              this.getCard.Reso_Tab_Tic_count = updateCount.overallTicket
              this.getCard.Resotabladher = updateCount.other_perc;
              this.getCard.Resol_adher_count = updateCount.other_count;
              this.getCard.resol_range_p1perc = updateCount.p1_perc;
              this.getCard.resol_range_p1count = updateCount.p1_count;
              this.FilterTic_Count = updateCount.overallTicket;
            }
            if (this.selection == 4) {
              this.selvalue = "reopen_range";
              this.getCard.Reopen_Tab_Tic_Count = updateCount.overallTicket;
              this.getCard.reopen_range_perc = updateCount.other_perc;
              this.getCard.reopen_range_p1count = updateCount.p1_count;
              this.getCard.reopen_range_p1perc = updateCount.p1_perc;
            }
            if (this.selection == 5) {
              this.selvalue = "reassign_range";
              this.getCard.Reassign_Tab_Tic_count = updateCount.overallTicket;
              this.getCard.reassign_range_perc = updateCount.other_perc;
              this.getCard.reassign_range_p1count = updateCount.p1_count;
              this.getCard.reassign_range_p1perc = updateCount.p1_perc;
            }
            insightInfo.rangein[this.selvalue][0] = this.slider.minValue;
            insightInfo.rangein[this.selvalue][1] = this.slider.maxValue;
            this.chartVisbility(this.selection);
            this.filterPopShow = false;
            this.clickInsightLoad = false
          } else {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong. Try after sometime!'
            })
          }
          this.fliterPopup.hide()
          this.clickInsightLoad = false
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: 'Sorry! Something went wrong. Try after sometime!'
          })
          this.fliterPopup.hide()
          this.clickInsightLoad = false
        })
    },
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.lzeroshow = true
    this.filterPopShow = false
    this.settingPopShow = false
    this.tempLoaderShow = false
    this.isTab1 = true
    this.showDeleteModal = false
    const startDate = ref(new Date())
    const EndDate = ref(new Date())
    this.startdt = startDate
    this.enddt = EndDate
    this.myColorArray = [new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(253, 55, 56, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(253, 55, 56, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(247, 99, 12, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(247, 99, 12, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 185, 0, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(255, 185, 0, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 192, 192, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(75, 192, 192, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 162, 235, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(54, 162, 235, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(136,23,152, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(136,23,152, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(168, 192, 255, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(168, 192, 255, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(255, 216, 155, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(255, 216, 155, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(178, 159, 148, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(178, 159, 148, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(54, 191, 54, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(54, 191, 54, 0.4)'
    }]),
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: 'rgba(75, 19, 79, 1.0)'
    }, {
      offset: 1,
      color: 'rgba(75, 19, 79, 0.4)'
    }]),
    ]
    this.myBorderArray = ['rgba(253, 55, 56, 0.9)',
      'rgba(247, 99, 12, 0.9)',
      'rgba(255, 185, 0, 0.9)',
      'rgba(75, 192, 192, 0.9)',
      'rgba(54, 162, 235, 0.9)',
      'rgba(136,23,152, 0.9)',
      'rgba(168, 192, 255,0.9)',
      'rgba(255, 216, 155,0.9)',
      'rgba(178, 159, 148, 0.9)',
      'rgba(54, 191,54,0.9)',
      'rgba(75, 19, 79, 0.9)'
    ]
    this.getAnalyse(0)
    window.addEventListener("resize", reportWindowSizeKI);
    this.fliterPopup = new Modal(document.getElementById('fliterPopup'))
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeKI);
  },
  computed: {
    dispstartdt() {
      return moment(this.startdt).format('DD-MMM-YY')
    },
    dispenddt() {
      return moment(this.enddt).format('DD-MMM-YY')
    },
  },
  watch: {
    $route() {
      let type = this.getQueryParams('type')
      if (type == 'keyDrill') {
        let currpass = this.getQueryParams('currpass')
        let filterop = this.getQueryParams('filterop')
        let kpos = this.getQueryParams('kpos')
        let optVal = this.getQueryParams('optVal')
        let inspos = this.getQueryParams('inspos')
        let sendobj = {
          "currpass": currpass.replaceAll('%20', ' '),
          "filterop": filterop,
          "kpos": kpos,
          "inspos": inspos,
          "whereFrom": 0,
          "optVal": optVal
        }
        this.drillkeyItem(sendobj, 0)
      }
      if (type == 'getExplain') {
        let currpass = this.getQueryParams('currpass')
        let sendobj = {
          "currpass": currpass.replaceAll('%20', ' '),
          "Cond": 0,
          "selid": selectedId,
        }
        this.$refs.explainPra.showExpModal(sendobj)
      }
    },
    '$store.state.chartColor': function () {
      if (myChart0 != undefined) {
        myChart0.setOption({ visualMap: { inRange: { color: this.$store.state.chartColor }, } })
      }
      if (myChart2 != undefined) {
        myChart2.setOption({ visualMap: { inRange: { color: this.$store.state.chartColor }, } })
      }
    },
    '$store.state.assDetails': function () {
      this.isLive = this.$store.state.assDetails.is_real
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  padding: 0;
  margin: 8px 0;
}

.insideli li {
  list-style-type: square;
}

.loader-inkeys {
  min-height: 368px;
  position: absolute;
  left: 0;
}

/* .loader-inkeys .loader_cog_cogs{
    position: static;
  } */
.darkTheme .tabA-label,
.darkTheme .tabB-label {
  position: relative;
}

/* .insideli::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
    text-indent: 0px !important;
    text-align: start !important;
    text-align-last: start !important;
  } */
.marbtm15 {
  margin-bottom: 15px;
}

legend {
  float: none;
  width: fit-content;
}

fieldset {
  border: 1px solid #777;
  border-radius: 10px;
  margin-left: 1%;
  font-size: 1rem;
}

.myRename {
  position: fixed;
  top: 31%;
  z-index: 20;
  width: 50%;
  left: 25%;
}

.tooltip-ins {
  position: relative;
}

.tooltip-ins .tooltiptext {
  visibility: hidden;
  width: 240px;
  background-color: inherit;
  color: #606060;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 99;
  bottom: 108%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  font-size: 0.8rem;
}

.tooltip-ins.infoT .tooltiptext {
  width: 450px;
  bottom: 145%;
  left: -290%;
}

.tooltip-ins.bottom .tooltiptext {
  bottom: auto;
  top: 108%;
}

.tooltip-ins .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

.tooltip-ins.bottom .tooltiptext {
  bottom: auto;
  top: 108%;
}

.tooltip-ins.bottom .tooltiptext::after {
  top: auto;
  bottom: 100%;
  border-color: transparent transparent #fff transparent;
}

.tooltip-ins:hover .tooltiptext {
  visibility: visible;
}

.tooltip-ins .tooltiptext {
  box-shadow: 1px 1px 2px 0 #d2dae3 inset, -1px -1px 2px 0 #d4d4d4 inset;
  color: #000;
  background-color: #fdfdfd;
}

.darkTheme .tooltip-ins .tooltiptext {
  box-shadow: 1px 1px 1px 0 #0b0a0a inset, -1px -1px 1px 0 #2b2b2b inset !important;
  color: #fff;
  background-color: #2c2c2c;
}

.darkTheme .tooltip-ins .tooltiptext::after {
  border-color: #262626 transparent transparent transparent;
}

.darkTheme .tooltip-ins.bottom .tooltiptext::after {
  border-color: transparent transparent #262626 transparent;
}

legend {
  /* font-size: 16px; */
  margin: 0 0 0 4px;
}

.drag-list .app {
  border-radius: 0;
}

section.wrapper {
  position: relative;
  top: 0;
  left: 0;
  /* width: 100%; */
}

.showAsmtSettings {
  width: calc(100% - 80px);
  margin: 0;
}
.showAsmtSettings::before{
  display:none;
}
.showAsmtSettings fieldset{
  margin: 0;
}

.card-quality .inner {
  min-height: 68px;
}

.tabAddSets .myfaBtn {
  height: 26px;
  width: 26px;
  padding: 2px;
}

.tabAddSets .myfaBtn svg {
  height: 18px;
  width: 18px;
  position: relative;
}

.has-tooltip:after {
  line-height: 1.5;
}

.tooltip-wrapper {
  position: absolute;
  visibility: hidden;
}

.has-tooltip:hover .tooltip-wrapper {
  visibility: visible;
  opacity: 0.7;
}

.has-tooltip .tooltip {
  display: block;
  position: relative;
  top: 2em;
  right: 100%;
  width: 140px;
  height: 96px;
  /*margin-left: -76px;*/
  color: #FFFFFF;
  background: #000000;
  line-height: 96px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 4px 3px 10px #800000;
}

.has-tooltip .tooltip:after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -8px;
  width: 0;
  height: 0;
  border-bottom: 8px solid #000000;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
}

.tab-contentV {
  margin-top: 0;
}

.filterSelect .selectPriority {
  padding: 0;
  border-width: 0px !important;
}

.keymsght {
  height: auto;
  width: 100px;
}

.keyerrm {
  display: block;
  width: 200px;
  margin: 0 auto;
  max-width: 100%;
}

.panel-card {
  position: relative;
  margin: 10px 0 20px;
  border-radius: 10px;
  padding: 20px;
}

#portfolioSnap {
  position: relative;
  overflow: hidden;
  padding: 20px 5px;
}

#portfolioSnap .content-panel1 {
  height: initial;
}

.dimChart {
  height: 300px;
}

.grpBtn2.grpBtnC.themeclr {
  color: #CC5500 !important;
  fill: #CC5500 !important;
  border-bottom: 2px solid #CC5500 !important;
}

.darkTheme .grpBtn2.grpBtnC.themeclr {
  color: #ecc257 !important;
  fill: #ecc257 !important;
  border-bottom: 2px solid #ecc257 !important;
}

.chartTitle {
  position: relative;
  top: 0;
  width: 60%;
  left: 0;
  margin: 0 auto;
}

.content-panel1.myObs {
  height: 100%;
  min-height: 360px;
}

.content-panel1.myObs.smallD {
  height: fit-content;
}

.reset-btn {
  background: none;
  outline: none;
  border: none;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>